export const Bell = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M18.062 15.4611C17.5263 14.9835 17.0572 14.436 16.6675 13.8333C16.2421 13.0014 15.9871 12.0929 15.9175 11.1611V8.41664C15.9212 6.95309 15.3903 5.53857 14.4246 4.43885C13.4589 3.33912 12.1248 2.6299 10.6731 2.44442V1.72775C10.6731 1.53105 10.595 1.3424 10.4559 1.20331C10.3168 1.06422 10.1281 0.986084 9.93142 0.986084C9.73472 0.986084 9.54608 1.06422 9.40699 1.20331C9.2679 1.3424 9.18976 1.53105 9.18976 1.72775V2.45553C7.75101 2.65438 6.43307 3.36789 5.48005 4.46392C4.52703 5.55995 4.0035 6.96422 4.00642 8.41664V11.1611C3.93684 12.0929 3.68186 13.0014 3.25642 13.8333C2.87358 14.4346 2.41209 14.982 1.8842 15.4611C1.82494 15.5131 1.77745 15.5772 1.74488 15.6491C1.71231 15.7209 1.69541 15.7989 1.69531 15.8778V16.6333C1.69531 16.7806 1.75384 16.922 1.85803 17.0261C1.96222 17.1303 2.10353 17.1889 2.25087 17.1889H17.6953C17.8427 17.1889 17.984 17.1303 18.0882 17.0261C18.1923 16.922 18.2509 16.7806 18.2509 16.6333V15.8778C18.2508 15.7989 18.2339 15.7209 18.2013 15.6491C18.1687 15.5772 18.1212 15.5131 18.062 15.4611ZM2.85087 16.0778C3.36776 15.5784 3.82287 15.0189 4.20642 14.4111C4.74232 13.4063 5.055 12.2978 5.12309 11.1611V8.41664C5.10106 7.76555 5.21027 7.11668 5.44423 6.50868C5.67818 5.90067 6.0321 5.34596 6.48489 4.87758C6.93769 4.4092 7.48011 4.03673 8.07986 3.78235C8.6796 3.52796 9.3244 3.39687 9.97587 3.39687C10.6273 3.39687 11.2721 3.52796 11.8719 3.78235C12.4716 4.03673 13.014 4.4092 13.4668 4.87758C13.9196 5.34596 14.2736 5.90067 14.5075 6.50868C14.7415 7.11668 14.8507 7.76555 14.8286 8.41664V11.1611C14.8967 12.2978 15.2094 13.4063 15.7453 14.4111C16.1289 15.0189 16.584 15.5784 17.1009 16.0778H2.85087Z"
			fill="black"
		/>
		<path
			d="M10.0006 19.0444C10.3506 19.0364 10.6864 18.9048 10.9487 18.673C11.211 18.4412 11.3829 18.1241 11.4339 17.7778H8.51172C8.5642 18.1335 8.74412 18.4581 9.018 18.6911C9.29188 18.9241 9.64107 19.0496 10.0006 19.0444Z"
			fill="black"
		/>
	</svg>
);

export const Briefcase = () => (
	<svg
		width="24"
		height="25"
		viewBox="0 0 24 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M20.25 6.20337H16.3125V5.26587C16.31 4.71962 16.0919 4.19645 15.7057 3.81019C15.3194 3.42393 14.7962 3.20584 14.25 3.20337H9.75C9.20375 3.20584 8.68058 3.42393 8.29432 3.81019C7.90806 4.19645 7.68997 4.71962 7.6875 5.26587V6.20337H3.75C3.4019 6.20337 3.06806 6.34165 2.82192 6.58779C2.57578 6.83393 2.4375 7.16777 2.4375 7.51587V19.5159C2.4375 19.864 2.57578 20.1978 2.82192 20.4439C3.06806 20.6901 3.4019 20.8284 3.75 20.8284H20.25C20.5981 20.8284 20.9319 20.6901 21.1781 20.4439C21.4242 20.1978 21.5625 19.864 21.5625 19.5159V7.51587C21.5625 7.16777 21.4242 6.83393 21.1781 6.58779C20.9319 6.34165 20.5981 6.20337 20.25 6.20337ZM8.8125 5.26587C8.8125 5.01723 8.91127 4.77877 9.08709 4.60296C9.2629 4.42714 9.50136 4.32837 9.75 4.32837H14.25C14.4986 4.32837 14.7371 4.42714 14.9129 4.60296C15.0887 4.77877 15.1875 5.01723 15.1875 5.26587V6.20337H8.8125V5.26587ZM3.75 7.32837H20.25C20.2997 7.32837 20.3474 7.34812 20.3826 7.38329C20.4177 7.41845 20.4375 7.46614 20.4375 7.51587V11.5284C17.855 12.9572 14.9514 13.7057 12 13.7034C9.04871 13.7045 6.14548 12.9561 3.5625 11.5284V7.51587C3.5625 7.46614 3.58225 7.41845 3.61742 7.38329C3.65258 7.34812 3.70027 7.32837 3.75 7.32837ZM20.25 19.7034H3.75C3.70027 19.7034 3.65258 19.6836 3.61742 19.6485C3.58225 19.6133 3.5625 19.5656 3.5625 19.5159V12.8034C6.17639 14.1331 9.06731 14.827 12 14.8284C14.9327 14.827 17.8236 14.1331 20.4375 12.8034V19.5159C20.4375 19.5656 20.4177 19.6133 20.3826 19.6485C20.3474 19.6836 20.2997 19.7034 20.25 19.7034ZM10.3125 11.2659C10.3125 11.1167 10.3718 10.9736 10.4773 10.8681C10.5827 10.7626 10.7258 10.7034 10.875 10.7034H13.125C13.2742 10.7034 13.4173 10.7626 13.5227 10.8681C13.6282 10.9736 13.6875 11.1167 13.6875 11.2659C13.6875 11.4151 13.6282 11.5581 13.5227 11.6636C13.4173 11.7691 13.2742 11.8284 13.125 11.8284H10.875C10.7258 11.8284 10.5827 11.7691 10.4773 11.6636C10.3718 11.5581 10.3125 11.4151 10.3125 11.2659Z"
			fill="#030659"
		/>
	</svg>
);

export const Bar = () => (
	<svg
		width="24"
		height="25"
		viewBox="0 0 24 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M21.375 19.4534H20.4375V4.26587C20.4375 4.11668 20.3782 3.97361 20.2727 3.86812C20.1673 3.76263 20.0242 3.70337 19.875 3.70337H14.625C14.4758 3.70337 14.3327 3.76263 14.2273 3.86812C14.1218 3.97361 14.0625 4.11668 14.0625 4.26587V8.20337H9.375C9.22582 8.20337 9.08274 8.26263 8.97725 8.36812C8.87176 8.47361 8.8125 8.61668 8.8125 8.76587V12.7034H4.125C3.97582 12.7034 3.83274 12.7626 3.72725 12.8681C3.62176 12.9736 3.5625 13.1167 3.5625 13.2659V19.4534H2.625C2.47582 19.4534 2.33274 19.5126 2.22725 19.6181C2.12176 19.7236 2.0625 19.8667 2.0625 20.0159C2.0625 20.1651 2.12176 20.3081 2.22725 20.4136C2.33274 20.5191 2.47582 20.5784 2.625 20.5784H21.375C21.5242 20.5784 21.6673 20.5191 21.7727 20.4136C21.8782 20.3081 21.9375 20.1651 21.9375 20.0159C21.9375 19.8667 21.8782 19.7236 21.7727 19.6181C21.6673 19.5126 21.5242 19.4534 21.375 19.4534ZM9.9375 9.32837H14.0625V19.4534H9.9375V9.32837ZM4.6875 13.8284H8.8125V19.4534H4.6875V13.8284ZM15.1875 19.4534V4.82837H19.3125V19.4534H15.1875Z"
			fill="black"
		/>
	</svg>
);

export const User = () => (
	<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M12 3.7041C12.7417 3.7041 13.4667 3.92404 14.0834 4.33609C14.7001 4.74815 15.1807 5.33382 15.4645 6.01904C15.7484 6.70426 15.8226 7.45826 15.6779 8.18569C15.5333 8.91312 15.1761 9.58131 14.6517 10.1058C14.1272 10.6302 13.459 10.9874 12.7316 11.132C12.0042 11.2767 11.2502 11.2025 10.5649 10.9186C9.87971 10.6348 9.29404 10.1542 8.88199 9.53749C8.46993 8.92081 8.25 8.19578 8.25 7.4541C8.25 6.45954 8.64509 5.50571 9.34835 4.80245C10.0516 4.09919 11.0054 3.7041 12 3.7041ZM12 2.2041C10.9616 2.2041 9.94661 2.51201 9.08326 3.08889C8.2199 3.66576 7.54699 4.4857 7.14963 5.44501C6.75227 6.40433 6.64831 7.45993 6.85088 8.47833C7.05345 9.49673 7.55346 10.4322 8.28769 11.1664C9.02192 11.9006 9.95738 12.4007 10.9758 12.6032C11.9942 12.8058 13.0498 12.7018 14.0091 12.3045C14.9684 11.9071 15.7883 11.2342 16.3652 10.3708C16.9421 9.50749 17.25 8.49245 17.25 7.4541C17.25 6.06172 16.6969 4.72636 15.7123 3.74179C14.7277 2.75722 13.3924 2.2041 12 2.2041ZM19.5 23.2041H18V19.4541C18 18.9616 17.903 18.474 17.7145 18.019C17.5261 17.5641 17.2499 17.1507 16.9017 16.8025C16.5534 16.4542 16.14 16.178 15.6851 15.9896C15.2301 15.8011 14.7425 15.7041 14.25 15.7041H9.75C8.75544 15.7041 7.80161 16.0992 7.09835 16.8025C6.39509 17.5057 6 18.4595 6 19.4541V23.2041H4.5V19.4541C4.5 18.0617 5.05312 16.7264 6.03769 15.7418C7.02226 14.7572 8.35761 14.2041 9.75 14.2041H14.25C15.6424 14.2041 16.9777 14.7572 17.9623 15.7418C18.9469 16.7264 19.5 18.0617 19.5 19.4541V23.2041Z" fill="black" />
	</svg>
);

export const MultipleUser = () => (
	<svg
		width="25"
		height="25"
		viewBox="0 0 25 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M23.2656 22.5159H21.7656V18.7659C21.7644 17.7717 21.369 16.8185 20.666 16.1155C19.963 15.4125 19.0098 15.0171 18.0156 15.0159V13.5159C19.4075 13.5175 20.742 14.0711 21.7262 15.0553C22.7104 16.0395 23.264 17.374 23.2656 18.7659V22.5159ZM17.2656 22.5159H15.7656V18.7659C15.7644 17.7717 15.369 16.8185 14.666 16.1155C13.963 15.4125 13.0098 15.0171 12.0156 15.0159H7.51562C6.52143 15.0171 5.56829 15.4125 4.86529 16.1155C4.16229 16.8185 3.76682 17.7717 3.76562 18.7659V22.5159H2.26562V18.7659C2.26721 17.374 2.82085 16.0395 3.80507 15.0553C4.78929 14.0711 6.12373 13.5175 7.51562 13.5159H12.0156C13.4075 13.5175 14.742 14.0711 15.7262 15.0553C16.7104 16.0395 17.264 17.374 17.2656 18.7659V22.5159ZM15.7656 1.51587V3.01587C16.7602 3.01587 17.714 3.41096 18.4173 4.11422C19.1205 4.81748 19.5156 5.77131 19.5156 6.76587C19.5156 7.76043 19.1205 8.71426 18.4173 9.41752C17.714 10.1208 16.7602 10.5159 15.7656 10.5159V12.0159C17.158 12.0159 18.4934 11.4627 19.4779 10.4782C20.4625 9.49361 21.0156 8.15826 21.0156 6.76587C21.0156 5.37348 20.4625 4.03812 19.4779 3.05356C18.4934 2.06899 17.158 1.51587 15.7656 1.51587ZM9.76562 3.01587C10.5073 3.01587 11.2323 3.2358 11.849 3.64786C12.4657 4.05991 12.9463 4.64558 13.2302 5.33081C13.514 6.01603 13.5883 6.77003 13.4436 7.49746C13.2989 8.22489 12.9417 8.89307 12.4173 9.41752C11.8928 9.94197 11.2246 10.2991 10.4972 10.4438C9.76978 10.5885 9.01579 10.5142 8.33056 10.2304C7.64534 9.94659 7.05967 9.46594 6.64761 8.84926C6.23556 8.23257 6.01562 7.50755 6.01562 6.76587C6.01562 5.77131 6.41071 4.81748 7.11397 4.11422C7.81724 3.41096 8.77106 3.01587 9.76562 3.01587ZM9.76562 1.51587C8.72727 1.51587 7.71224 1.82378 6.84888 2.40065C5.98552 2.97753 5.31262 3.79747 4.91526 4.75678C4.5179 5.71609 4.41393 6.77169 4.6165 7.79009C4.81907 8.80849 5.31909 9.74395 6.05331 10.4782C6.78754 11.2124 7.723 11.7124 8.7414 11.915C9.7598 12.1176 10.8154 12.0136 11.7747 11.6162C12.734 11.2189 13.554 10.546 14.1308 9.68261C14.7077 8.81925 15.0156 7.80422 15.0156 6.76587C15.0156 5.37348 14.4625 4.03812 13.4779 3.05356C12.4934 2.06899 11.158 1.51587 9.76562 1.51587Z"
			fill="black"
		/>
	</svg>
);

export const Free = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M23.25 19.5C23.25 21.5625 21.5625 23.25 19.5 23.25H4.5C2.4375 23.25 0.75 21.5625 0.75 19.5V4.5C0.75 2.4375 2.4375 0.75 4.5 0.75H19.5C21.5625 0.75 23.25 2.4375 23.25 4.5V19.5Z"
			fill="#4FD1D9"
		/>
		<path
			d="M12.75 15.375H15.75V14.25H13.8375V12.5625H15.75V11.4375H13.8375V9.75H15.75V8.625H12.75V15.375ZM20.25 9.75V8.625H17.25V15.375H20.25V14.25H18.3375V12.5625H20.25V11.4375H18.3375V9.75H20.25ZM8.9625 15.375V12.5625H9.375L10.3125 15.375H11.4375L10.4625 12.4125C11.1375 12.1125 11.625 11.4 11.625 10.575C11.625 9.4875 10.8 8.625 9.75 8.625H7.875V15.375H8.9625ZM8.9625 9.75H9.75C10.2 9.75 10.5375 10.125 10.5375 10.575C10.5375 11.025 10.1625 11.4 9.75 11.4H8.9625V9.75ZM4.8375 15.375V12.5625H6.75V11.4375H4.8375V9.75H6.75V8.625H3.75V15.375H4.8375Z"
			fill="white"
		/>
	</svg>
);

export const Logout = () => (
	<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M19 6.12012V5.12012C19 4.58968 18.7893 4.08098 18.4142 3.7059C18.0391 3.33083 17.5304 3.12012 17 3.12012H7C6.46957 3.12012 5.96086 3.33083 5.58579 3.7059C5.21071 4.08098 5 4.58968 5 5.12012V19.1201C5 19.6506 5.21071 20.1593 5.58579 20.5343C5.96086 20.9094 6.46957 21.1201 7 21.1201H17C17.5304 21.1201 18.0391 20.9094 18.4142 20.5343C18.7893 20.1593 19 19.6506 19 19.1201V18.1201M19 12.1201H12H19ZM12 12.1201L15 15.1201L12 12.1201ZM12 12.1201L15 9.12012L12 12.1201Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);

export const Message = () => (
	<svg
		width="25"
		height="25"
		viewBox="0 0 25 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M19.366 4.81592C20.1617 4.81592 20.9247 5.13199 21.4873 5.6946C22.0499 6.25721 22.366 7.02027 22.366 7.81592V17.4159C22.366 18.2116 22.0499 18.9746 21.4873 19.5372C20.9247 20.0998 20.1617 20.4159 19.366 20.4159H6.16602C5.37037 20.4159 4.6073 20.0998 4.0447 19.5372C3.48209 18.9746 3.16602 18.2116 3.16602 17.4159V7.81592C3.16602 7.02027 3.48209 6.25721 4.0447 5.6946C4.6073 5.13199 5.37037 4.81592 6.16602 4.81592H19.366ZM21.166 9.56912L13.0708 14.3331C12.9943 14.3781 12.9087 14.4054 12.8203 14.4133C12.7319 14.4212 12.6429 14.4094 12.5596 14.3787L12.4612 14.3331L4.36602 9.57152V17.4159C4.36602 17.8933 4.55566 18.3511 4.89322 18.6887C5.23079 19.0263 5.68863 19.2159 6.16602 19.2159H19.366C19.8434 19.2159 20.3012 19.0263 20.6388 18.6887C20.9764 18.3511 21.166 17.8933 21.166 17.4159V9.56912ZM19.366 6.01592H6.16602C5.68863 6.01592 5.23079 6.20556 4.89322 6.54313C4.55566 6.88069 4.36602 7.33853 4.36602 7.81592V8.17832L12.766 13.1199L21.166 8.17592V7.81592C21.166 7.33853 20.9764 6.88069 20.6388 6.54313C20.3012 6.20556 19.8434 6.01592 19.366 6.01592Z"
			fill="black"
		/>
	</svg>
);

export const JobFeed = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M5.99582 19.97C5.7337 19.97 5.47415 19.9184 5.23199 19.8181C4.98982 19.7178 4.76978 19.5708 4.58444 19.3854C4.39909 19.2001 4.25207 18.98 4.15176 18.7379C4.05145 18.4957 3.99982 18.2362 3.99982 17.974C3.99982 17.7119 4.05145 17.4524 4.15176 17.2102C4.25207 16.968 4.39909 16.748 4.58444 16.5627C4.76978 16.3773 4.98982 16.2303 5.23199 16.13C5.47415 16.0297 5.7337 15.978 5.99582 15.978C6.52519 15.978 7.03288 16.1883 7.40721 16.5627C7.78153 16.937 7.99182 17.4447 7.99182 17.974C7.99182 18.5034 7.78153 19.0111 7.40721 19.3854C7.03288 19.7597 6.52519 19.97 5.99582 19.97ZM5.11982 11.977C4.86082 12.0026 4.60206 11.926 4.39872 11.7636C4.19538 11.6011 4.06355 11.3657 4.03133 11.1074C3.99911 10.8492 4.06906 10.5885 4.22626 10.3811C4.38346 10.1737 4.61547 10.0359 4.87282 9.99704C6.01286 9.85454 7.17017 9.95611 8.26797 10.295C9.36576 10.6339 10.3789 11.2024 11.2403 11.9627C12.1016 12.723 12.7914 13.6578 13.2639 14.7051C13.7364 15.7524 13.9808 16.8881 13.9808 18.037V18.972C13.9808 19.2367 13.8757 19.4906 13.6885 19.6777C13.5014 19.8649 13.2475 19.97 12.9828 19.97C12.7181 19.97 12.4643 19.8649 12.2771 19.6777C12.09 19.4906 11.9848 19.2367 11.9848 18.972V18.038C11.9847 17.1721 11.8004 16.3161 11.4443 15.5268C11.0881 14.7374 10.5682 14.0329 9.919 13.4598C9.2698 12.8867 8.50617 12.4583 7.67877 12.2028C6.85136 11.9473 5.97909 11.8707 5.11982 11.978V11.977ZM3.99982 5.06504C3.99099 4.93416 4.00805 4.80282 4.05003 4.67853C4.092 4.55425 4.15807 4.43946 4.24444 4.34073C4.33082 4.242 4.43581 4.16127 4.55342 4.10316C4.67102 4.04504 4.79893 4.01068 4.92982 4.00204C12.7168 3.48304 19.4478 9.37404 19.9668 17.16C20.0088 17.786 20.0088 18.414 19.9668 19.04C19.9581 19.1708 19.9237 19.2986 19.8656 19.4161C19.8074 19.5336 19.7267 19.6385 19.6281 19.7248C19.5294 19.8112 19.4147 19.8772 19.2905 19.9192C19.1664 19.9612 19.0351 19.9783 18.9043 19.9695C18.7735 19.9608 18.6457 19.9264 18.5282 19.8683C18.4107 19.8102 18.3058 19.7295 18.2195 19.6308C18.1332 19.5321 18.0672 19.4174 18.0252 19.2933C17.9832 19.1691 17.9661 19.0378 17.9748 18.907C18.0108 18.369 18.0108 17.83 17.9748 17.293C17.5298 10.607 11.7498 5.54804 5.06482 5.99404C4.93378 6.00314 4.80223 5.98628 4.67771 5.94443C4.5532 5.90258 4.43817 5.83657 4.33923 5.75016C4.24028 5.66376 4.15937 5.55868 4.10112 5.44094C4.04288 5.32319 4.00846 5.19511 3.99982 5.06404V5.06504Z" fill="black" />
	</svg>
);

export const SelfDev = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M5.5 2C4.83696 2 4.20107 2.26339 3.73223 2.73223C3.26339 3.20107 3 3.83696 3 4.5V19.5C3 20.163 3.26339 20.7989 3.73223 21.2678C4.20107 21.7366 4.83696 22 5.5 22H12.81C12.3813 21.5537 12.0183 21.0486 11.732 20.5H5.5C5.23478 20.5 4.98043 20.3946 4.79289 20.2071C4.60536 20.0196 4.5 19.7652 4.5 19.5H11.313C11.1561 19.0134 11.0574 18.5099 11.019 18H4.5V4.5C4.5 4.23478 4.60536 3.98043 4.79289 3.79289C4.98043 3.60536 5.23478 3.5 5.5 3.5H17C17.2652 3.5 17.5196 3.60536 17.7071 3.79289C17.8946 3.98043 18 4.23478 18 4.5V11.019C18.52 11.059 19.022 11.159 19.5 11.313V4.5C19.5 3.83696 19.2366 3.20107 18.7678 2.73223C18.2989 2.26339 17.663 2 17 2H5.5ZM23 17.5C23 16.0413 22.4205 14.6424 21.3891 13.6109C20.3576 12.5795 18.9587 12 17.5 12C16.0413 12 14.6424 12.5795 13.6109 13.6109C12.5795 14.6424 12 16.0413 12 17.5C12 18.9587 12.5795 20.3576 13.6109 21.3891C14.6424 22.4205 16.0413 23 17.5 23C18.9587 23 20.3576 22.4205 21.3891 21.3891C22.4205 20.3576 23 18.9587 23 17.5ZM16.914 15.097L19.72 16.937C19.8069 16.9928 19.8783 17.0698 19.9273 17.1608C19.9762 17.2518 20.0013 17.3537 20 17.457C20.0001 17.561 19.9754 17.6635 19.928 17.756C19.8832 17.8476 19.8149 17.9256 19.73 17.982L16.923 19.897C16.8742 19.9299 16.821 19.9558 16.765 19.974C16.635 20.0155 16.4943 20.0073 16.37 19.951C16.2984 19.9175 16.2331 19.8718 16.177 19.816C16.1228 19.757 16.0789 19.6894 16.047 19.616C16.0158 19.5409 15.9998 19.4603 16 19.379V15.621C15.9995 15.5007 16.0339 15.3828 16.099 15.2816C16.1642 15.1804 16.2572 15.1003 16.367 15.051C16.4542 15.0101 16.5505 14.9928 16.6465 15.0007C16.7424 15.0086 16.8347 15.0414 16.914 15.096V15.097ZM6 6C6 5.73478 6.10536 5.48043 6.29289 5.29289C6.48043 5.10536 6.73478 5 7 5H15C15.2652 5 15.5196 5.10536 15.7071 5.29289C15.8946 5.48043 16 5.73478 16 6V8C16 8.26522 15.8946 8.51957 15.7071 8.70711C15.5196 8.89464 15.2652 9 15 9H7C6.73478 9 6.48043 8.89464 6.29289 8.70711C6.10536 8.51957 6 8.26522 6 8V6ZM7.5 7.5H14.5V6.5H7.5V7.5Z" fill="black" />
	</svg>
);

export const Test = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M7.5 16H16.5M19.75 7.75H15.25C14.9848 7.75 14.7304 7.64464 14.5429 7.45711C14.3554 7.26957 14.25 7.01522 14.25 6.75V2.25H5.25C4.98478 2.25 4.73043 2.35536 4.54289 2.54289C4.35536 2.73043 4.25 2.98478 4.25 3.25V20.75C4.25 21.0152 4.35536 21.2696 4.54289 21.4571C4.73043 21.6446 4.98478 21.75 5.25 21.75H18.75C19.0152 21.75 19.2696 21.6446 19.4571 21.4571C19.6446 21.2696 19.75 21.0152 19.75 20.75V7.75ZM14.25 2.25L19.75 7.75L14.25 2.25ZM7.5 11.5H16.5H7.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);

export const Media = () => (
	<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M16.5 19.5H1.5C1.1023 19.4996 0.720997 19.3414 0.439779 19.0602C0.15856 18.779 0.000397108 18.3977 0 18V7.5C0.000397108 7.1023 0.15856 6.721 0.439779 6.43978C0.720997 6.15856 1.1023 6.0004 1.5 6H16.5C16.8977 6.0004 17.279 6.15856 17.5602 6.43978C17.8414 6.721 17.9996 7.1023 18 7.5V18C17.9996 18.3977 17.8414 18.779 17.5602 19.0602C17.279 19.3414 16.8977 19.4996 16.5 19.5ZM1.5 7.5V18H16.5V7.5H1.5ZM1.5 3H16.5V4.5H1.5V3ZM3 0H15V1.5H3V0Z" fill="black" />
		<path d="M7 9.5V15.5L12.25 12.5L7 9.5Z" fill="black" />
	</svg>
);

export const AdvancedSearch = () => (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M17 17.2041L13.2223 13.4197L17 17.2041ZM15.3158 8.362C15.3158 10.2604 14.5617 12.081 13.2193 13.4234C11.8769 14.7658 10.0563 15.5199 8.15789 15.5199C6.2595 15.5199 4.43886 14.7658 3.0965 13.4234C1.75413 12.081 1 10.2604 1 8.362C1 6.4636 1.75413 4.64297 3.0965 3.3006C4.43886 1.95823 6.2595 1.2041 8.15789 1.2041C10.0563 1.2041 11.8769 1.95823 13.2193 3.3006C14.5617 4.64297 15.3158 6.4636 15.3158 8.362V8.362Z" stroke="gray" stroke-width="1.5" stroke-linecap="round" />
	</svg>
);

export const Sort = () => (
	<svg
		width="18"
		height="24"
		viewBox="0 0 18 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M5.86076 9.60155L8.95368 6.92989L12.0466 9.60155L12.9967 8.77905L8.95368 5.27905L4.91064 8.77905L5.86076 9.60155Z"
			fill="black"
		/>
		<path
			d="M5.86076 14.6172L8.95368 17.2947L12.0466 14.6172L12.9967 15.4455L8.95368 18.9455L4.91064 15.4455L5.86076 14.6172Z"
			fill="black"
		/>
	</svg>
);

export const ActivitySummary = () => (
	<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M2 14.2041V15.7041H5.4395L0.5 20.6436L1.5605 21.7041L6.5 16.7646V20.2041H8V14.2041H2ZM17 14.9541H18.5V18.7041H17V14.9541ZM14 11.2041H15.5V18.7041H14V11.2041ZM11 12.7041H12.5V18.7041H11V12.7041Z" fill="black" />
		<path d="M20 0.704102H2C1.6023 0.704499 1.221 0.862661 0.939778 1.14388C0.65856 1.4251 0.500397 1.8064 0.5 2.2041V11.2041H2V8.9541H20.0007L20.0015 20.2041H11V21.7041H20C20.3976 21.7035 20.7788 21.5453 21.06 21.2641C21.3412 20.9829 21.4994 20.6017 21.5 20.2041V2.2041C21.4996 1.8064 21.3414 1.4251 21.0602 1.14388C20.779 0.862661 20.3977 0.704499 20 0.704102ZM8 7.4541H2V2.2041H8V7.4541ZM9.5 7.4541V2.2041H20V7.4541H9.5Z" fill="black" />
	</svg>
);

export const Settings = () => (
	<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_446_1610)">
			<path d="M12.3556 7.42822C9.75563 7.42822 7.68896 9.49489 7.68896 12.0949C7.68896 14.6949 9.75563 16.7616 12.3556 16.7616C14.9556 16.7616 17.0223 14.6949 17.0223 12.0949C17.0223 9.49489 14.9556 7.42822 12.3556 7.42822ZM12.3556 15.4282C10.489 15.4282 9.0223 13.9616 9.0223 12.0949C9.0223 10.2282 10.489 8.76156 12.3556 8.76156C14.2223 8.76156 15.689 10.2282 15.689 12.0949C15.689 13.9616 14.2223 15.4282 12.3556 15.4282Z" fill="black" />
			<path d="M22.1559 9.89489L20.2892 9.29489L19.8892 8.29489L20.8226 6.56156C21.0226 6.16156 20.9559 5.62822 20.6226 5.29489L19.0226 3.69489C18.6892 3.36156 18.1559 3.29489 17.7559 3.49489L16.0226 4.42822L15.0226 4.02822L14.4226 2.16156C14.2892 1.76156 13.8892 1.42822 13.4226 1.42822H11.1559C10.6892 1.42822 10.2892 1.76156 10.2226 2.22822L9.62256 4.09489C9.22256 4.16156 8.88922 4.29489 8.55589 4.49489L6.82256 3.56156C6.42256 3.36156 5.88923 3.42822 5.55589 3.76156L3.95589 5.36156C3.62256 5.69489 3.55589 6.22822 3.75589 6.62822L4.62256 8.29489C4.48923 8.62822 4.35589 9.02822 4.22256 9.36156L2.35589 9.96156C1.95589 10.0949 1.62256 10.4949 1.62256 10.9616V13.2282C1.62256 13.6949 1.95589 14.0949 2.42256 14.2282L4.28923 14.8282L4.68922 15.8282L3.75589 17.5616C3.55589 17.9616 3.62256 18.4949 3.95589 18.8282L5.55589 20.4282C5.88923 20.7616 6.42256 20.8282 6.82256 20.6282L8.55589 19.6949L9.55589 20.0949L10.1559 22.0282C10.2892 22.4282 10.6892 22.7616 11.1559 22.7616H13.4226C13.8892 22.7616 14.2892 22.4282 14.4226 22.0282L15.0226 20.0949L16.0226 19.6949L17.7559 20.6282C18.1559 20.8282 18.6892 20.7616 19.0226 20.4282L20.6226 18.8282C20.9559 18.4949 21.0226 17.9616 20.8226 17.5616L19.8892 15.8282L20.2892 14.8282L22.2226 14.2282C22.6226 14.0949 22.9559 13.6949 22.9559 13.2282V10.9616C22.9559 10.4949 22.6226 10.0282 22.1559 9.89489ZM21.6226 13.0282L19.2226 13.7616L19.1559 14.0949L18.5559 15.4949L18.3559 15.8282L19.5559 18.0282L18.2226 19.3616L16.0226 18.1616L15.6892 18.3616C15.2226 18.6282 14.7559 18.8282 14.2892 18.9616L13.9559 19.0282L13.2226 21.4282H11.3559L10.6226 19.0282L10.2892 18.9616L8.88922 18.3616L8.55589 18.1616L6.35589 19.3616L5.02256 18.0282L6.22256 15.8282L6.02256 15.4949C5.75589 15.0282 5.55589 14.5616 5.42256 14.0949L5.35589 13.7616L2.95589 13.0282V11.1616L5.22256 10.4949L5.35589 10.1616C5.48922 9.62822 5.68923 9.16156 5.95589 8.69489L6.15589 8.36156L5.02256 6.16156L6.35589 4.82822L8.48922 6.02822L8.82256 5.82822C9.28923 5.56156 9.75589 5.36156 10.2892 5.22822L10.6226 5.09489L11.3559 2.76156H13.2226L13.9559 5.09489L14.2892 5.22822C14.7559 5.36156 15.2226 5.56156 15.6892 5.82822L16.0226 6.02822L18.2226 4.82822L19.5559 6.16156L18.3559 8.36156L18.5559 8.69489C18.8226 9.16156 19.0226 9.62822 19.1559 10.0949L19.2226 10.4282L21.6226 11.1616V13.0282Z" fill="black" />
		</g>
		<defs>
			<clipPath id="clip0_446_1610">
				<rect width="24" height="24" fill="white" transform="translate(0.289062 0.0947266)" />
			</clipPath>
		</defs>
	</svg>
);

export const Star = ({ onClick, fill = false }) => (
	<svg
		width="21"
		height="21"
		viewBox="0 0 21 21"
		fill={fill ? "#FFD700" : "none"} // Yellow when filled, none when not
		xmlns="http://www.w3.org/2000/svg"
		onClick={onClick}
		style={{ cursor: "pointer" }}
	>
		<g clipPath="url(#clip0_911_3163)">
			<path
				d="M13.1112 7.8553L13.2234 8.20078H13.5867H18.934C19.4286 8.20078 19.7777 8.26063 20.0003 8.3447C20.2266 8.43017 20.2524 8.51067 20.2529 8.51198C20.2533 8.51323 20.2797 8.59348 20.1469 8.79559C20.0162 8.99441 19.7688 9.24803 19.3683 9.53881L19.3682 9.53889L15.0434 12.6807L14.7495 12.8942L14.8618 13.2398L16.5145 18.3255C16.6673 18.7958 16.7181 19.1462 16.7069 19.3838C16.6955 19.6254 16.6269 19.675 16.6256 19.6759C16.6243 19.6768 16.556 19.7267 16.3227 19.6629C16.0932 19.6 15.7756 19.4432 15.3753 19.1522L15.3751 19.1521L11.0494 16.0103L10.7555 15.7969L10.4617 16.0103L6.1369 19.1521L6.13675 19.1522C5.73652 19.4432 5.41888 19.6 5.18938 19.6629C4.95612 19.7267 4.88776 19.6768 4.8865 19.6759C4.88521 19.675 4.81661 19.6254 4.80518 19.3838C4.79394 19.1462 4.8448 18.7958 4.99757 18.3255L4.99758 18.3255L6.64941 13.2397L6.76161 12.8942L6.46773 12.6807L2.14293 9.53889L2.14288 9.53885C1.74252 9.24807 1.49524 8.99446 1.36459 8.79566C1.23201 8.5939 1.25816 8.51358 1.25866 8.51204L1.25866 8.51204L1.25866 8.51203C1.25916 8.51048 1.28529 8.43005 1.51131 8.3447C1.73391 8.26063 2.083 8.20078 2.57759 8.20078H7.92446H8.28773L8.39999 7.8553L10.0523 2.77044L10.0523 2.77027C10.2051 2.29947 10.3699 1.98573 10.5186 1.79989C10.6696 1.61128 10.754 1.61133 10.7556 1.61133H10.7556H10.7556C10.7571 1.61133 10.8416 1.61128 10.9925 1.79989C11.1412 1.98573 11.306 2.29947 11.4588 2.77027L11.4589 2.77044L13.1112 7.8553Z"
				stroke="#808080"
			/>
		</g>
		<defs>
			<clipPath id="clip0_911_3163">
				<rect
					width="20"
					height="20"
					fill="white"
					transform="translate(0.755859 0.65332)"
				/>
			</clipPath>
		</defs>
	</svg>
);
export const StarFavorite = ({ onClick, fill = false, disabled }) => (
	<svg
	  width="24"
	  height="23"
	  viewBox="0 0 24 23"
	  fill="none"
	  xmlns="http://www.w3.org/2000/svg"
	  onClick={disabled ? undefined : onClick}
      style={{ cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : 1 }}	>
	  <g clip-path="url(#clip0_12115_16430)">
		<path
		  d="M21.8135 7.94302H15.3967L13.414 2.21155C12.6327 -0.0496821 11.3661 -0.0496821 10.5848 2.21155L8.60208 7.94302H2.18583C-0.343387 7.94302 -0.735707 9.07416 1.31159 10.4708L6.50136 14.0122L4.51916 19.7447C3.73786 22.0038 4.7629 22.7043 6.80965 21.3065L11.9994 17.7652L17.1903 21.3065C19.237 22.7043 20.2621 22.0038 19.4808 19.7447L17.4975 14.0122L22.6872 10.4708C24.7351 9.07416 24.3428 7.94302 21.8135 7.94302Z"
		  fill={fill ? "url(#paint0_linear_12115_16430)" : "none"}
		  stroke={fill ? "none" : "#999"}
		  strokeWidth={fill ? 0 : 1}
		/>
	  </g>
	  <defs>
		<linearGradient
		  id="paint0_linear_12115_16430"
		  x1="11.9996"
		  y1="0.515625"
		  x2="11.9996"
		  y2="22.0262"
		  gradientUnits="userSpaceOnUse"
		>
		  <stop stop-color="#F9A910" />
		  <stop offset="1" stop-color="#DD9204" />
		</linearGradient>
		<clipPath id="clip0_12115_16430">
		  <rect width="24" height="22.5433" fill="white" />
		</clipPath>
	  </defs>
	</svg>
);

export const Share = ({ onClick }) => (
	<svg
		width="21"
		height="21"
		viewBox="0 0 21 21"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		onClick={onClick}
	>
		<path
			d="M15.1309 12.8468C14.6631 12.8492 14.2018 12.9565 13.781 13.161C13.3602 13.3654 12.9906 13.6617 12.6997 14.0281L8.13091 11.1718C8.29742 10.6344 8.29742 10.0592 8.13091 9.52181L12.6997 6.66556C13.1634 7.23975 13.8154 7.63129 14.5401 7.77081C15.2649 7.91033 16.0156 7.78883 16.6594 7.42782C17.3031 7.06682 17.7983 6.48962 18.0572 5.79846C18.3162 5.10731 18.3221 4.34682 18.074 3.6517C17.8259 2.95659 17.3398 2.37172 16.7018 2.0007C16.0637 1.62968 15.315 1.49646 14.5881 1.62464C13.8613 1.75282 13.2033 2.13412 12.7306 2.70101C12.258 3.26789 12.0013 3.98376 12.0059 4.72181C12.0089 5.00129 12.0509 5.27899 12.1309 5.54681L7.56216 8.40306C7.15882 7.8953 6.6075 7.52559 5.98463 7.34518C5.36177 7.16477 4.6982 7.1826 4.08592 7.39619C3.47364 7.60978 2.94297 8.00856 2.56747 8.53725C2.19197 9.06593 1.99023 9.69834 1.99023 10.3468C1.99023 10.9953 2.19197 11.6277 2.56747 12.1564C2.94297 12.6851 3.47364 13.0838 4.08592 13.2974C4.6982 13.511 5.36177 13.5288 5.98463 13.3484C6.6075 13.168 7.15882 12.7983 7.56216 12.2906L12.1309 15.1468C12.0509 15.4146 12.0089 15.6923 12.0059 15.9718C12.0059 16.5899 12.1892 17.1941 12.5326 17.708C12.8759 18.2219 13.364 18.6224 13.935 18.8589C14.506 19.0955 15.1344 19.1573 15.7406 19.0368C16.3468 18.9162 16.9036 18.6186 17.3406 18.1815C17.7777 17.7445 18.0753 17.1877 18.1959 16.5815C18.3164 15.9753 18.2546 15.3469 18.018 14.7759C17.7815 14.2049 17.381 13.7168 16.8671 13.3735C16.3532 13.0301 15.749 12.8468 15.1309 12.8468ZM15.1309 2.84681C15.5018 2.84681 15.8643 2.95677 16.1726 3.1628C16.4809 3.36883 16.7213 3.66166 16.8632 4.00428C17.0051 4.34689 17.0422 4.72389 16.9699 5.0876C16.8975 5.45132 16.719 5.78541 16.4567 6.04763C16.1945 6.30986 15.8604 6.48843 15.4967 6.56078C15.133 6.63313 14.756 6.596 14.4134 6.45408C14.0708 6.31217 13.7779 6.07184 13.5719 5.7635C13.3659 5.45516 13.2559 5.09265 13.2559 4.72181C13.2559 4.22453 13.4535 3.74761 13.8051 3.39598C14.1567 3.04435 14.6336 2.84681 15.1309 2.84681ZM5.13091 12.2218C4.76007 12.2218 4.39756 12.1118 4.08922 11.9058C3.78088 11.6998 3.54055 11.4069 3.39864 11.0643C3.25672 10.7217 3.21959 10.3447 3.29194 9.98101C3.36429 9.6173 3.54286 9.2832 3.80509 9.02098C4.06731 8.75876 4.4014 8.58018 4.76512 8.50783C5.12883 8.43549 5.50583 8.47262 5.84844 8.61453C6.19106 8.75645 6.48389 8.99677 6.68992 9.30511C6.89595 9.61345 7.00591 9.97597 7.00591 10.3468C7.00591 10.8441 6.80837 11.321 6.45674 11.6726C6.10511 12.0243 5.62819 12.2218 5.13091 12.2218ZM15.1309 17.8468C14.7601 17.8468 14.3976 17.7368 14.0892 17.5308C13.7809 17.3248 13.5406 17.0319 13.3986 16.6893C13.2567 16.3467 13.2196 15.9697 13.2919 15.606C13.3643 15.2423 13.5429 14.9082 13.8051 14.646C14.0673 14.3838 14.4014 14.2052 14.7651 14.1328C15.1288 14.0605 15.5058 14.0976 15.8484 14.2395C16.1911 14.3814 16.4839 14.6218 16.6899 14.9301C16.8959 15.2385 17.0059 15.601 17.0059 15.9718C17.0059 16.4691 16.8084 16.946 16.4567 17.2976C16.1051 17.6493 15.6282 17.8468 15.1309 17.8468Z"
			fill="#030659"
		/>
	</svg>
);

export const SideBarArrow = () => (
	<svg
		height="20"
		viewBox="0 0 24 24"
		width="20"
		xmlns="http://www.w3.org/2000/svg"
		icon="caret-right"
		fill="#030659"
	>
		<path d="M13.5857864,12 L9.29289322,7.70710678 C8.90236893,7.31658249 8.90236893,6.68341751 9.29289322,6.29289322 C9.68341751,5.90236893 10.3165825,5.90236893 10.7071068,6.29289322 L15.7071068,11.2928932 C16.0976311,11.6834175 16.0976311,12.3165825 15.7071068,12.7071068 L10.7071068,17.7071068 C10.3165825,18.0976311 9.68341751,18.0976311 9.29289322,17.7071068 C8.90236893,17.3165825 8.90236893,16.6834175 9.29289322,16.2928932 L13.5857864,12 Z"></path>
	</svg>
);

export const Wifi = () => (
	<svg
		width="17"
		height="17"
		viewBox="0 0 17 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M2.99631 16.97C2.73419 16.97 2.47464 16.9183 2.23247 16.818C1.99031 16.7177 1.77027 16.5707 1.58492 16.3854C1.39958 16.2 1.25255 15.98 1.15225 15.7378C1.05194 15.4956 1.00031 15.2361 1.00031 14.974C1.00031 14.7119 1.05194 14.4523 1.15225 14.2101C1.25255 13.968 1.39958 13.7479 1.58492 13.5626C1.77027 13.3772 1.99031 13.2302 2.23247 13.1299C2.47464 13.0296 2.73419 12.978 2.99631 12.978C3.52568 12.978 4.03337 13.1883 4.40769 13.5626C4.78202 13.9369 4.99231 14.4446 4.99231 14.974C4.99231 15.5033 4.78202 16.011 4.40769 16.3854C4.03337 16.7597 3.52568 16.97 2.99631 16.97ZM2.12031 8.97698C1.86131 9.00258 1.60255 8.92599 1.39921 8.76353C1.19587 8.60108 1.06404 8.36562 1.03182 8.10736C0.999601 7.84909 1.06955 7.58846 1.22675 7.38103C1.38394 7.1736 1.61596 7.03579 1.87331 6.99698C3.01335 6.85448 4.17066 6.95605 5.26845 7.29494C6.36625 7.63384 7.37942 8.20231 8.24075 8.96264C9.10209 9.72298 9.79188 10.6578 10.2644 11.705C10.7369 12.7523 10.9812 13.8881 10.9813 15.037V15.972C10.9813 16.2367 10.8762 16.4905 10.689 16.6777C10.5018 16.8648 10.248 16.97 9.98331 16.97C9.71862 16.97 9.46478 16.8648 9.27762 16.6777C9.09046 16.4905 8.98531 16.2367 8.98531 15.972V15.038C8.98518 14.172 8.80093 13.316 8.44477 12.5267C8.08861 11.7374 7.56868 11.0328 6.91949 10.4598C6.27029 9.88668 5.50666 9.4582 4.67926 9.20273C3.85185 8.94727 2.97958 8.87066 2.12031 8.97798V8.97698ZM1.00031 2.06498C0.991481 1.93409 1.00854 1.80276 1.05052 1.67847C1.09249 1.55419 1.15856 1.4394 1.24493 1.34067C1.33131 1.24194 1.4363 1.16121 1.5539 1.10309C1.67151 1.04498 1.79941 1.01062 1.93031 1.00198C9.71731 0.482976 16.4483 6.37398 16.9673 14.16C17.0093 14.786 17.0093 15.414 16.9673 16.04C16.9586 16.1708 16.9242 16.2986 16.866 16.4161C16.8079 16.5336 16.7272 16.6385 16.6286 16.7248C16.5299 16.8111 16.4152 16.8771 16.291 16.9191C16.1668 16.9611 16.0356 16.9782 15.9048 16.9695C15.774 16.9607 15.6462 16.9263 15.5287 16.8682C15.4112 16.8101 15.3063 16.7294 15.22 16.6307C15.1337 16.5321 15.0677 16.4174 15.0257 16.2932C14.9837 16.169 14.9666 16.0378 14.9753 15.907C15.0113 15.369 15.0113 14.83 14.9753 14.293C14.5303 7.60698 8.75031 2.54798 2.06531 2.99398C1.93427 3.00308 1.80271 2.98622 1.6782 2.94437C1.55369 2.90252 1.43866 2.8365 1.33971 2.7501C1.24077 2.6637 1.15986 2.55862 1.10161 2.44087C1.04337 2.32313 1.00894 2.19505 1.00031 2.06398V2.06498Z"
			fill="#EB9B01"
		/>
	</svg>
);

export const LocationIcon = () => (
	<svg
		width="18"
		height="22"
		viewBox="0 0 18 22"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M9.34347 0.928589C11.5599 0.928589 13.6856 1.80907 15.2529 3.37634C16.8201 4.94361 17.7006 7.06928 17.7006 9.28573C17.7006 12.8172 15.2192 16.6657 10.3206 20.8726C10.0482 21.1066 9.70095 21.2351 9.34187 21.2348C8.98278 21.2345 8.63573 21.1053 8.36376 20.8709L8.03976 20.5897C3.35804 16.4926 0.986328 12.7383 0.986328 9.28573C0.986328 7.06928 1.86681 4.94361 3.43408 3.37634C5.00135 1.80907 7.12702 0.928589 9.34347 0.928589ZM9.34347 2.2143C7.46801 2.2143 5.66937 2.95933 4.34322 4.28548C3.01707 5.61163 2.27204 7.41027 2.27204 9.28573C2.27204 12.2874 4.45604 15.746 8.88404 19.6203L9.20376 19.8972C9.24263 19.9306 9.2922 19.949 9.34347 19.949C9.39474 19.949 9.44431 19.9306 9.48318 19.8972C14.1255 15.9097 16.4149 12.3586 16.4149 9.28573C16.4149 8.3571 16.232 7.43756 15.8766 6.57961C15.5212 5.72167 15.0004 4.94212 14.3437 4.28548C13.6871 3.62883 12.9075 3.10796 12.0496 2.75258C11.1916 2.39721 10.2721 2.2143 9.34347 2.2143ZM9.34347 6.07145C10.196 6.07145 11.0135 6.41009 11.6163 7.01289C12.2191 7.61568 12.5578 8.43325 12.5578 9.28573C12.5578 10.1382 12.2191 10.9558 11.6163 11.5586C11.0135 12.1614 10.196 12.5 9.34347 12.5C8.49099 12.5 7.67342 12.1614 7.07063 11.5586C6.46783 10.9558 6.12918 10.1382 6.12918 9.28573C6.12918 8.43325 6.46783 7.61568 7.07063 7.01289C7.67342 6.41009 8.49099 6.07145 9.34347 6.07145ZM9.34347 7.35716C8.83198 7.35716 8.34144 7.56035 7.97976 7.92203C7.61809 8.2837 7.4149 8.77424 7.4149 9.28573C7.4149 9.79722 7.61809 10.2878 7.97976 10.6494C8.34144 11.0111 8.83198 11.2143 9.34347 11.2143C9.85496 11.2143 10.3455 11.0111 10.7072 10.6494C11.0689 10.2878 11.272 9.79722 11.272 9.28573C11.272 8.77424 11.0689 8.2837 10.7072 7.92203C10.3455 7.56035 9.85496 7.35716 9.34347 7.35716Z"
			fill="#333333"
		/>
	</svg>
);

export const Matches = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect x="0.5" y="0.5" width="19" height="19" stroke="black" />
		<path
			d="M7.50033 11.6667C7.50033 9.58335 8.22949 7.81252 9.68783 6.35419C11.1462 4.89585 12.917 4.16669 15.0003 4.16669V5.83335C13.3753 5.83335 11.997 6.39919 10.8653 7.53085C9.7331 8.66308 9.16699 10.0417 9.16699 11.6667H7.50033ZM10.8337 11.6667C10.8337 10.5139 11.24 9.53113 12.0528 8.71835C12.865 7.90613 13.8475 7.50002 15.0003 7.50002V9.16669C14.3059 9.16669 13.7156 9.40974 13.2295 9.89585C12.7434 10.382 12.5003 10.9722 12.5003 11.6667H10.8337ZM4.16699 5.00002C3.70866 5.00002 3.31616 4.83669 2.98949 4.51002C2.66338 4.18391 2.50033 3.79169 2.50033 3.33335C2.50033 2.87502 2.66338 2.48252 2.98949 2.15585C3.31616 1.82974 3.70866 1.66669 4.16699 1.66669C4.62533 1.66669 5.01755 1.82974 5.34366 2.15585C5.67033 2.48252 5.83366 2.87502 5.83366 3.33335C5.83366 3.79169 5.67033 4.18391 5.34366 4.51002C5.01755 4.83669 4.62533 5.00002 4.16699 5.00002ZM1.66699 9.16669V7.08335C1.66699 6.73613 1.78866 6.44113 2.03199 6.19835C2.27477 5.95502 2.56977 5.83335 2.91699 5.83335H5.41699C6.04199 5.83335 6.58033 5.6353 7.03199 5.23919C7.4831 4.84363 7.76421 4.34724 7.87533 3.75002H9.54199C9.45866 4.58335 9.1531 5.31946 8.62533 5.95835C8.09755 6.59724 7.44477 7.04169 6.66699 7.29169V9.16669H1.66699ZM15.8337 14.1667C15.3753 14.1667 14.9828 14.0036 14.6562 13.6775C14.33 13.3509 14.167 12.9584 14.167 12.5C14.167 12.0417 14.33 11.6492 14.6562 11.3225C14.9828 10.9964 15.3753 10.8334 15.8337 10.8334C16.292 10.8334 16.6845 10.9964 17.0112 11.3225C17.3373 11.6492 17.5003 12.0417 17.5003 12.5C17.5003 12.9584 17.3373 13.3509 17.0112 13.6775C16.6845 14.0036 16.292 14.1667 15.8337 14.1667ZM13.3337 18.3334V16.4584C12.5559 16.2084 11.9031 15.7639 11.3753 15.125C10.8475 14.4861 10.542 13.75 10.4587 12.9167H12.1253C12.2364 13.5139 12.5175 14.0106 12.9687 14.4067C13.4203 14.8022 13.9587 15 14.5837 15H17.0837C17.4309 15 17.7259 15.1217 17.9687 15.365C18.212 15.6078 18.3337 15.9028 18.3337 16.25V18.3334H13.3337Z"
			fill="black"
		/>
	</svg>
);

export const Eye = () => (
	<svg
		width="22"
		height="16"
		viewBox="0 0 22 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M20.2565 6.962C20.7305 7.582 20.7305 8.419 20.2565 9.038C18.7635 10.987 15.1815 15 10.9995 15C6.81752 15 3.23552 10.987 1.74252 9.038C1.51191 8.74113 1.38672 8.37592 1.38672 8C1.38672 7.62408 1.51191 7.25887 1.74252 6.962C3.23552 5.013 6.81752 1 10.9995 1C15.1815 1 18.7635 5.013 20.2565 6.962Z"
			stroke="#808080"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M11 11C12.6569 11 14 9.65685 14 8C14 6.34315 12.6569 5 11 5C9.34315 5 8 6.34315 8 8C8 9.65685 9.34315 11 11 11Z"
			stroke="#808080"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const Support = () => (
	<svg
		version="1.1"
		id="Layer_1"
		xmlns="http://www.w3.org/2000/svg"
		// xmlns:xlink="http://www.w3.org/1999/xlink"
		x="0px"
		y="0px"
		viewBox="0 0 512 512"
	// style={enableBackground:"new 0 0 512 512"}
	// xml:space="preserve"
	>
		<g>
			<g>
				<path
					d="M452.028,222.199C447.087,131.883,361.062,59.733,256,59.733S64.913,131.883,59.972,222.199
			C25.745,224.683,0,242.372,0,264.533v34.133c0,23.927,29.986,42.667,68.267,42.667c4.719,0,8.533-3.814,8.533-8.533V230.4
			c0-84.693,80.393-153.6,179.2-153.6s179.2,68.907,179.2,153.6v98.867l-20.599,20.599h-17.664
			c8.115-20.659,12.664-43.401,12.664-67.32c0-93.585-68.907-169.719-153.6-169.719s-153.6,76.134-153.6,169.719
			S171.307,452.267,256,452.267c56.883,0,106.53-34.423,133.077-85.333h29.056c2.27,0,4.437-0.896,6.033-2.5l23.159-23.159
			c36.548-1.126,64.674-19.43,64.674-42.607v-34.133C512,242.372,486.255,224.683,452.028,222.199z M378.351,349.875h-79.684
			c0-14.114-11.486-25.6-25.6-25.6h-34.133c-14.114,0-25.6,11.486-25.6,25.6v17.067c0,14.114,11.486,25.6,25.6,25.6h34.133
			c14.114,0,25.6-11.486,25.6-25.6h71.014C345.19,408.038,303.394,435.2,256,435.2c-75.281,0-136.533-68.471-136.533-152.653
			S180.719,129.903,256,129.903s136.533,68.471,136.533,152.653C392.533,306.739,387.345,329.532,378.351,349.875z"
				/>
			</g>
		</g>
		<g></g>
		<g></g>
		<g></g>
		<g></g>
		<g></g>
		<g></g>
		<g></g>
		<g></g>
		<g></g>
		<g></g>
		<g></g>
		<g></g>
		<g></g>
		<g></g>
		<g></g>
	</svg>
);

export const CheckMark = () => (
	<svg
		width="13"
		height="9"
		viewBox="0 0 13 9"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M5.35645 8.99972L0.856445 4.49972L1.56345 3.79272L5.35645 7.58522L12.1494 0.792725L12.8564 1.49972L5.35645 8.99972Z"
			fill="#FB1A1A"
		/>
	</svg>
);
export const ChevronDown = ({ color }) => (
	<svg
		width="11"
		height="8"
		viewBox="0 0 11 8"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M10.3828 0.320312L5.38281 6.32031L0.382812 0.320312"
			stroke={color}
		/>
	</svg>
);
export const Plus = () => (
	<svg
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M13.3628 7.63587H7.63587V13.3628H5.7269V7.63587H0V5.7269H5.7269V0H7.63587V5.7269H13.3628V7.63587Z"
			fill="#152238"
		/>
	</svg>
);

export const Globe = () => (
	<svg
		width="19"
		height="18"
		viewBox="0 0 19 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_1_11807)">
			<path
				d="M16.1555 5.47504C16.0398 5.45257 15.953 5.44133 15.8952 5.44133C15.4671 5.44133 15.0969 5.58177 14.7845 5.86264C14.0787 5.5593 13.4193 5.31213 12.8061 5.12114C11.7995 4.80657 10.7467 4.54817 9.64757 4.34594C9.54345 4.07631 9.38726 3.85161 9.179 3.67185C9.46824 2.34615 9.85583 1.14403 10.3418 0.0654907C11.7995 0.166604 13.1387 0.576673 14.3593 1.2957C15.5799 2.01472 16.5662 2.95845 17.3183 4.12686C16.8902 4.57625 16.5026 5.02564 16.1555 5.47504ZM8.10303 3.28425C7.80221 3.28425 7.51876 3.3629 7.25266 3.52018C6.31552 2.8461 5.37259 2.27312 4.42388 1.80126C5.85851 0.745195 7.46669 0.166604 9.24842 0.0654907C8.7972 1.04292 8.43276 2.11584 8.15509 3.28425H8.10303ZM2.08102 4.32909C2.47439 3.68871 2.97189 3.08203 3.57351 2.50905C4.36024 2.90227 5.1759 3.38537 6.02049 3.95834C4.528 3.92464 3.21485 4.04822 2.08102 4.32909ZM6.437 5.00317C6.46014 5.35145 6.58451 5.6576 6.81012 5.92162C7.03573 6.18564 7.31629 6.36258 7.65181 6.45246C7.58239 7.2389 7.54768 7.98601 7.54768 8.6938C7.54768 9.18813 7.56504 9.75549 7.59975 10.3959C7.34521 10.4745 7.11961 10.6093 6.92292 10.8003C6.29816 10.5644 5.69654 10.2948 5.11806 9.99142C5.24532 9.74425 5.30896 9.49147 5.30896 9.23307C5.30896 8.78368 5.14698 8.4017 4.82303 8.08712C4.49908 7.77255 4.10571 7.61526 3.64293 7.61526C3.13386 7.61526 2.71157 7.80625 2.37605 8.18823C1.89012 7.76131 1.45626 7.31754 1.07446 6.85691C1.17859 6.37382 1.33478 5.89634 1.54304 5.42448C2.95453 5.0425 4.58585 4.90206 6.437 5.00317ZM1.99425 9.36789C2.02896 9.78357 2.2054 10.1347 2.52356 10.4211C2.84173 10.7076 3.21485 10.8509 3.64293 10.8509C3.77019 10.8509 3.90903 10.8284 4.05943 10.7835C4.79989 11.1992 5.59241 11.5587 6.437 11.862V11.9294C6.437 12.3676 6.59029 12.7411 6.89689 13.0501C7.20349 13.359 7.58239 13.5248 8.03361 13.5472C8.32285 14.9179 8.72779 16.1705 9.24842 17.3053C8.09146 17.2378 6.99812 16.9654 5.96843 16.4879C4.93873 16.0104 4.05076 15.3897 3.30451 14.6258C2.55827 13.8618 1.96533 12.963 1.52568 11.9294C1.08603 10.8958 0.866211 9.81728 0.866211 8.6938C0.866211 8.68256 0.871996 8.5309 0.883565 8.23879C1.20752 8.63201 1.57774 9.00837 1.99425 9.36789ZM9.5608 12.6878C10.3938 12.8338 11.2326 12.9293 12.0772 12.9742C12.1582 13.1989 12.2855 13.4068 12.459 13.5978C12.1929 14.7774 12.0309 15.9234 11.9731 17.0356C11.383 17.1817 10.8392 17.2716 10.3418 17.3053C9.79798 16.1031 9.37569 14.7437 9.07488 13.227C9.28313 13.0922 9.4451 12.9125 9.5608 12.6878ZM14.9407 13.4967C15.0911 13.3169 15.1952 13.1259 15.2531 12.9237C16.0977 12.8563 16.9133 12.7496 17.7 12.6035C17.1447 13.6596 16.3811 14.5752 15.4093 15.3504C15.3051 14.7662 15.1489 14.1483 14.9407 13.4967ZM12.1119 11.8957C11.302 11.8508 10.5037 11.7497 9.71699 11.5924C9.58973 11.0306 9.25999 10.643 8.72779 10.4296C8.68151 9.76672 8.65837 9.18813 8.65837 8.6938C8.65837 7.9523 8.69308 7.18272 8.7625 6.38505C8.78563 6.38505 8.81456 6.37382 8.84927 6.35135C8.88398 6.32888 8.90712 6.31764 8.91869 6.31764C9.3699 6.74457 9.76327 7.13778 10.0988 7.4973C11.1053 8.57583 11.9615 9.80042 12.6673 11.1711C12.4127 11.3621 12.2276 11.6036 12.1119 11.8957ZM13.6565 14.0865C13.6796 14.0865 13.7432 14.0809 13.8474 14.0696C14.044 14.755 14.1887 15.4347 14.2812 16.1088C13.9457 16.2997 13.5408 16.4907 13.0664 16.6817C13.1474 15.8054 13.2862 14.9347 13.4829 14.0696C13.5755 14.0809 13.6333 14.0865 13.6565 14.0865ZM13.5697 10.0588C13.5581 10.0813 13.5437 10.115 13.5263 10.1599C13.5089 10.2049 13.4945 10.2386 13.4829 10.2611C12.754 8.98029 11.8979 7.81749 10.9144 6.77265C10.5558 6.37944 10.1277 5.95251 9.63022 5.49189C9.64179 5.49189 9.65047 5.48346 9.65625 5.46661L9.66493 5.44133C10.6368 5.63232 11.5681 5.86825 12.459 6.14912C13.0028 6.31764 13.5986 6.54234 14.2465 6.82321C14.2234 6.93556 14.2118 7.01982 14.2118 7.07599C14.2118 7.41303 14.3159 7.72199 14.5242 8.00286C14.1424 8.71065 13.8242 9.39597 13.5697 10.0588ZM14.3853 11.0363C14.5242 10.643 14.5936 10.4408 14.5936 10.4296C14.825 9.86783 15.1142 9.26677 15.4613 8.62639C15.6117 8.67133 15.7563 8.6938 15.8952 8.6938C16.2886 8.6938 16.6414 8.5646 16.9538 8.3062C17.5207 8.68818 18.0761 9.1151 18.6198 9.58696C18.5504 10.2273 18.4116 10.8453 18.2033 11.4407C17.2546 11.6317 16.2538 11.7665 15.201 11.8452C15.0506 11.4856 14.7787 11.216 14.3853 11.0363ZM17.5612 7.05914C17.5612 6.68839 17.4339 6.35135 17.1794 6.04801C17.4224 5.74467 17.6653 5.46942 17.9083 5.22225C18.3248 6.1435 18.5678 7.09284 18.6372 8.07027C18.2554 7.7894 17.8852 7.53662 17.5265 7.31192C17.5496 7.21081 17.5612 7.12655 17.5612 7.05914Z"
				fill="#CDCEE5"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1_11807">
				<rect
					width="17.7714"
					height="17.2398"
					fill="white"
					transform="translate(0.866211 0.0654907)"
				/>
			</clipPath>
		</defs>
	</svg>
);

export const NextIcon = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M3 12C3 16.9688 7.03125 21 12 21C16.9688 21 21 16.9688 21 12C21 7.03125 16.9688 3 12 3C7.03125 3 3 7.03125 3 12Z"
			stroke="black"
			stroke-miterlimit="10"
		/>
		<path
			d="M10.125 16.5L14.625 12L10.125 7.5"
			stroke="black"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
export const PrevIcon = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M12 3C7.03125 3 3 7.03125 3 12C3 16.9688 7.03125 21 12 21C16.9688 21 21 16.9688 21 12C21 7.03125 16.9688 3 12 3Z"
			stroke="black"
			stroke-miterlimit="10"
		/>
		<path
			d="M13.875 16.5L9.375 12L13.875 7.5"
			stroke="black"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

export const CalenderIcon = ({ className }) => (
	<svg
		width="17"
		height="15"
		viewBox="0 0 17 15"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<g clip-path="url(#clip0_1_11788)">
			<path
				d="M1.83486 13.2664H4.49443V11.0164H1.83486V13.2664ZM5.08545 13.2664H8.04053V11.0164H5.08545V13.2664ZM1.83486 10.5164H4.49443V8.01636H1.83486V10.5164ZM5.08545 10.5164H8.04053V8.01636H5.08545V10.5164ZM1.83486 7.51636H4.49443V5.26636H1.83486V7.51636ZM8.63154 13.2664H11.5866V11.0164H8.63154V13.2664ZM5.08545 7.51636H8.04053V5.26636H5.08545V7.51636ZM12.1776 13.2664H14.8372V11.0164H12.1776V13.2664ZM8.63154 10.5164H11.5866V8.01636H8.63154V10.5164ZM5.38096 3.76636V1.51636C5.38096 1.44865 5.35171 1.39006 5.29323 1.34058C5.23474 1.2911 5.16548 1.26636 5.08545 1.26636H4.49443C4.4144 1.26636 4.34514 1.2911 4.28665 1.34058C4.22817 1.39006 4.19892 1.44865 4.19892 1.51636V3.76636C4.19892 3.83407 4.22817 3.89266 4.28665 3.94214C4.34514 3.99162 4.4144 4.01636 4.49443 4.01636H5.08545C5.16548 4.01636 5.23474 3.99162 5.29323 3.94214C5.35171 3.89266 5.38096 3.83407 5.38096 3.76636ZM12.1776 10.5164H14.8372V8.01636H12.1776V10.5164ZM8.63154 7.51636H11.5866V5.26636H8.63154V7.51636ZM12.1776 7.51636H14.8372V5.26636H12.1776V7.51636ZM12.4731 3.76636V1.51636C12.4731 1.44865 12.4439 1.39006 12.3854 1.34058C12.3269 1.2911 12.2577 1.26636 12.1776 1.26636H11.5866C11.5066 1.26636 11.4373 1.2911 11.3788 1.34058C11.3204 1.39006 11.2911 1.44865 11.2911 1.51636V3.76636C11.2911 3.83407 11.3204 3.89266 11.3788 3.94214C11.4373 3.99162 11.5066 4.01636 11.5866 4.01636H12.1776C12.2577 4.01636 12.3269 3.99162 12.3854 3.94214C12.4439 3.89266 12.4731 3.83407 12.4731 3.76636ZM16.0192 3.26636V13.2664C16.0192 13.5372 15.9023 13.7716 15.6683 13.9695C15.4344 14.1674 15.1573 14.2664 14.8372 14.2664H1.83486C1.51473 14.2664 1.23769 14.1674 1.00375 13.9695C0.769804 13.7716 0.652832 13.5372 0.652832 13.2664V3.26636C0.652832 2.99552 0.769804 2.76115 1.00375 2.56323C1.23769 2.36532 1.51473 2.26636 1.83486 2.26636H3.01689V1.51636C3.01689 1.17261 3.16157 0.878337 3.45092 0.633545C3.74027 0.388753 4.08811 0.266357 4.49443 0.266357H5.08545C5.49177 0.266357 5.83961 0.388753 6.12896 0.633545C6.41831 0.878337 6.56299 1.17261 6.56299 1.51636V2.26636H10.1091V1.51636C10.1091 1.17261 10.2538 0.878337 10.5431 0.633545C10.8325 0.388753 11.1803 0.266357 11.5866 0.266357H12.1776C12.584 0.266357 12.9318 0.388753 13.2211 0.633545C13.5105 0.878337 13.6552 1.17261 13.6552 1.51636V2.26636H14.8372C15.1573 2.26636 15.4344 2.36532 15.6683 2.56323C15.9023 2.76115 16.0192 2.99552 16.0192 3.26636Z"
				fill="#CDCEE5"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1_11788">
				<rect
					width="15.368"
					height="14"
					fill="white"
					transform="translate(0.652344 0.266357)"
				/>
			</clipPath>
		</defs>
	</svg>
);

export const CloseIcon = ({ color }) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M15.7108 8.2899C15.6178 8.19617 15.5072 8.12177 15.3854 8.071C15.2635 8.02024 15.1328 7.9941 15.0008 7.9941C14.8688 7.9941 14.7381 8.02024 14.6162 8.071C14.4944 8.12177 14.3838 8.19617 14.2908 8.2899L12.0008 10.5899L9.71081 8.2899C9.52251 8.10159 9.26711 7.9958 9.00081 7.9958C8.73451 7.9958 8.47912 8.10159 8.29081 8.2899C8.10251 8.4782 7.99672 8.73359 7.99672 8.9999C7.99672 9.2662 8.10251 9.52159 8.29081 9.7099L10.5908 11.9999L8.29081 14.2899C8.19708 14.3829 8.12269 14.4935 8.07192 14.6153C8.02115 14.7372 7.99501 14.8679 7.99501 14.9999C7.99501 15.1319 8.02115 15.2626 8.07192 15.3845C8.12269 15.5063 8.19708 15.6169 8.29081 15.7099C8.38378 15.8036 8.49438 15.878 8.61624 15.9288C8.73809 15.9796 8.8688 16.0057 9.00081 16.0057C9.13282 16.0057 9.26353 15.9796 9.38539 15.9288C9.50725 15.878 9.61785 15.8036 9.71081 15.7099L12.0008 13.4099L14.2908 15.7099C14.3838 15.8036 14.4944 15.878 14.6162 15.9288C14.7381 15.9796 14.8688 16.0057 15.0008 16.0057C15.1328 16.0057 15.2635 15.9796 15.3854 15.9288C15.5072 15.878 15.6178 15.8036 15.7108 15.7099C15.8045 15.6169 15.8789 15.5063 15.9297 15.3845C15.9805 15.2626 16.0066 15.1319 16.0066 14.9999C16.0066 14.8679 15.9805 14.7372 15.9297 14.6153C15.8789 14.4935 15.8045 14.3829 15.7108 14.2899L13.4108 11.9999L15.7108 9.7099C15.8045 9.61693 15.8789 9.50633 15.9297 9.38447C15.9805 9.26261 16.0066 9.13191 16.0066 8.9999C16.0066 8.86788 15.9805 8.73718 15.9297 8.61532C15.8789 8.49346 15.8045 8.38286 15.7108 8.2899ZM19.0708 4.9299C18.1483 3.97479 17.0449 3.21297 15.8249 2.68888C14.6048 2.16479 13.2926 1.88893 11.9648 1.87739C10.637 1.86585 9.32024 2.11887 8.09127 2.62168C6.86231 3.12449 5.74579 3.86702 4.80686 4.80595C3.86794 5.74487 3.1254 6.86139 2.6226 8.09036C2.11979 9.31932 1.86677 10.6361 1.87831 11.9639C1.88985 13.2917 2.16571 14.6039 2.6898 15.8239C3.21389 17.044 3.97571 18.1474 4.93081 19.0699C5.85328 20.025 6.95673 20.7868 8.17677 21.3109C9.39681 21.835 10.709 22.1109 12.0368 22.1224C13.3646 22.1339 14.6814 21.8809 15.9104 21.3781C17.1393 20.8753 18.2558 20.1328 19.1948 19.1938C20.1337 18.2549 20.8762 17.1384 21.379 15.9094C21.8818 14.6805 22.1349 13.3637 22.1233 12.0359C22.1118 10.7081 21.8359 9.39589 21.3118 8.17585C20.7877 6.95581 20.0259 5.85236 19.0708 4.9299ZM17.6608 17.6599C16.3529 18.9693 14.6314 19.7847 12.7896 19.9672C10.9479 20.1497 9.09982 19.688 7.56033 18.6607C6.02085 17.6334 4.88517 16.1041 4.34679 14.3334C3.8084 12.5627 3.90062 10.66 4.60773 8.94968C5.31483 7.23932 6.59309 5.82704 8.2247 4.95346C9.85632 4.07987 11.7404 3.79903 13.5558 4.15877C15.3713 4.51851 17.0059 5.49659 18.1811 6.92636C19.3563 8.35613 19.9994 10.1491 20.0008 11.9999C20.0044 13.0512 19.7994 14.0927 19.3977 15.0643C18.9961 16.0358 18.4057 16.918 17.6608 17.6599Z"
			fill={color || "white"}
		/>
	</svg>
);

export const FileIcon = () => (
	<svg
		width="33"
		height="41"
		viewBox="0 0 33 41"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M7.31217 28.6667H25.6872M32.3226 11.8229H23.1351C22.5936 11.8229 22.0743 11.6078 21.6914 11.2249C21.3085 10.842 21.0934 10.3227 21.0934 9.78125V0.59375H2.71842C2.17694 0.59375 1.65764 0.808853 1.27475 1.19174C0.891862 1.57463 0.676758 2.09393 0.676758 2.63542V38.3646C0.676758 38.9061 0.891862 39.4254 1.27475 39.8083C1.65764 40.1911 2.17694 40.4063 2.71842 40.4063H30.2809C30.8224 40.4063 31.3417 40.1911 31.7246 39.8083C32.1075 39.4254 32.3226 38.9061 32.3226 38.3646V11.8229ZM21.0934 0.59375L32.3226 11.8229L21.0934 0.59375ZM7.31217 19.4792H25.6872H7.31217Z"
			stroke="black"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

export const CancelIcon = ({ onClick }) => (
	<svg
		width="26"
		height="26"
		viewBox="0 0 26 26"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		onClick={onClick}
	>
		<path
			d="M22.1529 4.05108C24.5534 6.45155 25.9019 9.70728 25.9019 13.1021C25.9019 16.4968 24.5534 19.7526 22.1529 22.153C19.7524 24.5535 16.4967 25.9021 13.1019 25.9021C9.70716 25.9021 6.45143 24.5535 4.05097 22.153C1.6505 19.7526 0.301934 16.4968 0.301934 13.1021C0.301934 9.70728 1.6505 6.45155 4.05097 4.05108C6.45143 1.65062 9.70716 0.30205 13.1019 0.302051C16.4967 0.302051 19.7524 1.65062 22.1529 4.05108ZM8.57645 17.6275C8.72648 17.7776 8.92996 17.8618 9.14214 17.8618C9.35431 17.8618 9.55779 17.7776 9.70782 17.6275L13.1019 14.2334L16.496 17.6275C16.6461 17.7776 16.8496 17.8619 17.0617 17.8619C17.2739 17.8618 17.4774 17.7776 17.6274 17.6275C17.7774 17.4775 17.8617 17.274 17.8617 17.0618C17.8617 16.8497 17.7774 16.6462 17.6274 16.4962L14.2333 13.1021L17.6274 9.70794C17.7774 9.55791 17.8617 9.35443 17.8617 9.14225C17.8617 8.93008 17.7774 8.7266 17.6274 8.57657C17.4774 8.42654 17.2739 8.34225 17.0617 8.34225C16.8496 8.34225 16.6461 8.42654 16.496 8.57657L13.1019 11.9707L9.70782 8.57657C9.55779 8.42654 9.35431 8.34225 9.14214 8.34225C8.92996 8.34225 8.72648 8.42654 8.57645 8.57657C8.42642 8.7266 8.34214 8.93008 8.34214 9.14225C8.34214 9.35443 8.42642 9.55791 8.57645 9.70794L11.9706 13.1021L8.57645 16.4962C8.42642 16.6462 8.34214 16.8497 8.34214 17.0618C8.34214 17.274 8.42642 17.4775 8.57645 17.6275Z"
			fill="#FF6161"
		/>
	</svg>
);

export const VerifiedIcon = ({ onClick }) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M9.59224 3.20003C9.43441 3.34168 9.26917 3.47487 9.09724 3.59903C8.79924 3.79903 8.46424 3.93703 8.11224 4.00703C7.95924 4.03703 7.79924 4.05003 7.48024 4.07503C6.67924 4.13903 6.27824 4.17103 5.94424 4.28903C5.56223 4.42368 5.21527 4.64224 4.92886 4.92865C4.64245 5.21506 4.42389 5.56202 4.28924 5.94403C4.17124 6.27803 4.13924 6.67903 4.07524 7.48003C4.06375 7.69175 4.04106 7.90271 4.00724 8.11203C3.93724 8.46403 3.79924 8.79903 3.59924 9.09703C3.51224 9.22703 3.40824 9.34903 3.20024 9.59203C2.67924 10.204 2.41824 10.51 2.26524 10.83C1.91224 11.57 1.91224 12.43 2.26524 13.17C2.41824 13.49 2.67924 13.796 3.20024 14.408C3.40824 14.651 3.51224 14.773 3.59924 14.903C3.79924 15.201 3.93724 15.536 4.00724 15.888C4.03724 16.041 4.05024 16.201 4.07524 16.52C4.13924 17.321 4.17124 17.722 4.28924 18.056C4.42389 18.438 4.64245 18.785 4.92886 19.0714C5.21527 19.3578 5.56223 19.5764 5.94424 19.711C6.27824 19.829 6.67924 19.861 7.48024 19.925C7.79924 19.95 7.95924 19.963 8.11224 19.993C8.46424 20.063 8.79924 20.202 9.09724 20.401C9.22724 20.488 9.34924 20.592 9.59224 20.8C10.2042 21.321 10.5102 21.582 10.8302 21.735C11.5702 22.088 12.4302 22.088 13.1702 21.735C13.4902 21.582 13.7962 21.321 14.4082 20.8C14.6512 20.592 14.7732 20.488 14.9032 20.401C15.2012 20.201 15.5362 20.063 15.8882 19.993C16.0412 19.963 16.2012 19.95 16.5202 19.925C17.3212 19.861 17.7222 19.829 18.0562 19.711C18.4382 19.5764 18.7852 19.3578 19.0716 19.0714C19.358 18.785 19.5766 18.438 19.7112 18.056C19.8292 17.722 19.8612 17.321 19.9252 16.52C19.9502 16.201 19.9632 16.041 19.9932 15.888C20.0632 15.536 20.2022 15.201 20.4012 14.903C20.4882 14.773 20.5922 14.651 20.8002 14.408C21.3212 13.796 21.5822 13.49 21.7352 13.17C22.0882 12.43 22.0882 11.57 21.7352 10.83C21.5822 10.51 21.3212 10.204 20.8002 9.59203C20.6586 9.4342 20.5254 9.26896 20.4012 9.09703C20.2011 8.79908 20.0624 8.46422 19.9932 8.11203C19.9594 7.90271 19.9367 7.69175 19.9252 7.48003C19.8612 6.67903 19.8292 6.27803 19.7112 5.94403C19.5766 5.56202 19.358 5.21506 19.0716 4.92865C18.7852 4.64224 18.4382 4.42368 18.0562 4.28903C17.7222 4.17103 17.3212 4.13903 16.5202 4.07503C16.3085 4.06354 16.0976 4.04085 15.8882 4.00703C15.536 3.93785 15.2012 3.79915 14.9032 3.59903C14.7313 3.47487 14.5661 3.34168 14.4082 3.20003C13.7962 2.67903 13.4902 2.41803 13.1702 2.26503C12.805 2.0902 12.4052 1.99945 12.0002 1.99945C11.5953 1.99945 11.1955 2.0902 10.8302 2.26503C10.5102 2.41803 10.2042 2.67903 9.59224 3.20003ZM16.3732 9.86303C16.5146 9.70834 16.5908 9.5051 16.5861 9.29562C16.5814 9.08614 16.496 8.88655 16.3479 8.73839C16.1997 8.59022 16.0001 8.5049 15.7906 8.50018C15.5812 8.49545 15.3779 8.57169 15.2232 8.71303L10.3732 13.563L8.77724 11.968C8.62255 11.8267 8.41931 11.7505 8.20983 11.7552C8.00035 11.7599 7.80076 11.8452 7.6526 11.9934C7.50443 12.1415 7.41911 12.3411 7.41439 12.5506C7.40966 12.7601 7.4859 12.9633 7.62724 13.118L9.79724 15.288C9.94984 15.4403 10.1566 15.5259 10.3722 15.5259C10.5878 15.5259 10.7946 15.4403 10.9472 15.288L16.3732 9.86303Z"
			fill="#009A49"
		/>
	</svg>
);

export const ModalCloseIcon = ({ onClick }) => (
	<svg
		width="12"
		height="12"
		viewBox="0 0 12 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		onClick={onClick}
	>
		<path
			d="M1 1L11 11M1 11L11 1"
			stroke="black"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
export const MarkDoneIcon = ({ onClick }) => (
	<svg
		width="21"
		height="21"
		viewBox="0 0 21 21"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		onClick={onClick}
	>
		<path
			d="M17.3075 1.92499L21 5.61749L7.385 19.25L0 11.8562L3.6925 8.16374L7.385 11.8562L17.3075 1.92499ZM17.3075 4.37499L7.385 14.315L3.6925 10.6662L2.45875 11.8562L7.385 16.7737L18.5413 5.61749L17.3075 4.37499Z"
			fill="#04097B"
		/>
	</svg>
);

export const MarkCancelIcon = ({ onClick }) => (
	<svg
		width="26"
		height="26"
		viewBox="0 0 26 26"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		onClick={onClick}
	>
		<path
			d="M21.6663 7.48581L18.5138 4.33331L12.9997 9.84748L7.48551 4.33331L4.33301 7.48581L9.84717 13L4.33301 18.5141L7.48551 21.6666L12.9997 16.1525L18.5138 21.6666L21.6663 18.5141L16.1522 13L21.6663 7.48581Z"
			fill="#FB1A1A"
		/>
	</svg>
);

export const TalentSearchIcon = () => (
	<svg
		width="20"
		height="22"
		viewBox="0 0 20 22"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M10.7988 0.935303C9.52576 0.935303 8.30486 1.44102 7.40469 2.34119C6.50451 3.24136 5.9988 4.46226 5.9988 5.7353C5.9988 7.00834 6.50451 8.22924 7.40469 9.12941C8.30486 10.0296 9.52576 10.5353 10.7988 10.5353C12.0718 10.5353 13.2927 10.0296 14.1929 9.12941C15.0931 8.22924 15.5988 7.00834 15.5988 5.7353C15.5988 4.46226 15.0931 3.24136 14.1929 2.34119C13.2927 1.44102 12.0718 0.935303 10.7988 0.935303ZM7.1988 5.7353C7.1988 4.78052 7.57808 3.86485 8.25321 3.18972C8.92835 2.51459 9.84402 2.1353 10.7988 2.1353C11.7536 2.1353 12.6693 2.51459 13.3444 3.18972C14.0195 3.86485 14.3988 4.78052 14.3988 5.7353C14.3988 6.69008 14.0195 7.60576 13.3444 8.28089C12.6693 8.95602 11.7536 9.3353 10.7988 9.3353C9.84402 9.3353 8.92835 8.95602 8.25321 8.28089C7.57808 7.60576 7.1988 6.69008 7.1988 5.7353ZM16.6368 18.6917C15.3516 19.5113 13.692 19.9685 11.8824 20.0969C11.7921 19.8586 11.6522 19.6423 11.472 19.4621L10.944 18.9341C12.966 18.9149 14.736 18.4793 15.9912 17.6789C17.2512 16.8749 17.9988 15.7073 17.9988 14.1353C17.9988 13.817 17.8724 13.5118 17.6473 13.2868C17.4223 13.0617 17.1171 12.9353 16.7988 12.9353H9.2916C9.14151 12.5118 8.93914 12.1087 8.6892 11.7353H16.7988C17.4353 11.7353 18.0458 11.9882 18.4959 12.4382C18.9459 12.8883 19.1988 13.4988 19.1988 14.1353C19.1988 16.1645 18.1992 17.6945 16.6368 18.6917ZM4.1988 18.9353C5.142 18.9353 6.0132 18.6233 6.714 18.0989L9.774 21.1589C9.82971 21.2147 9.89585 21.259 9.96867 21.2892C10.0415 21.3194 10.1195 21.335 10.1984 21.335C10.2772 21.3351 10.3553 21.3196 10.4281 21.2895C10.501 21.2594 10.5672 21.2152 10.623 21.1595C10.6788 21.1038 10.7231 21.0376 10.7533 20.9648C10.7835 20.892 10.7991 20.814 10.7991 20.7351C10.7992 20.6563 10.7837 20.5782 10.7536 20.5054C10.7235 20.4325 10.6793 20.3663 10.6236 20.3105L7.5636 17.2505C8.13001 16.493 8.42417 15.5666 8.39845 14.6211C8.37273 13.6756 8.02863 12.7665 7.42187 12.0409C6.81511 11.3154 5.98122 10.8159 5.05521 10.6233C4.1292 10.4307 3.16529 10.5563 2.31956 10.9798C1.47383 11.4032 0.795799 12.0998 0.395242 12.9566C-0.00531545 13.8134 -0.104942 14.7804 0.112495 15.7008C0.329931 16.6213 0.851699 17.4415 1.59331 18.0285C2.33493 18.6155 3.25298 18.935 4.1988 18.9353ZM4.1988 17.7353C3.40315 17.7353 2.64009 17.4192 2.07748 16.8566C1.51487 16.294 1.1988 15.531 1.1988 14.7353C1.1988 13.9397 1.51487 13.1766 2.07748 12.614C2.64009 12.0514 3.40315 11.7353 4.1988 11.7353C4.99445 11.7353 5.75751 12.0514 6.32012 12.614C6.88273 13.1766 7.1988 13.9397 7.1988 14.7353C7.1988 15.531 6.88273 16.294 6.32012 16.8566C5.75751 17.4192 4.99445 17.7353 4.1988 17.7353Z"
			fill="black"
		/>
	</svg>
);


export const EditIcon = ({ onClick }) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		onClick={onClick}
	>
		<rect width="23.8563" height="24" rx="4" fill="#219653" />
		<path
			d="M16.8988 10.75V17.9375C16.8988 18.1427 16.8586 18.3459 16.7806 18.5354C16.7025 18.725 16.5881 18.8973 16.4439 19.0424C16.2997 19.1874 16.1284 19.3025 15.94 19.3811C15.7516 19.4596 15.5496 19.5 15.3456 19.5H6.02678C5.61486 19.5 5.21981 19.3354 4.92854 19.0424C4.63727 18.7493 4.47363 18.3519 4.47363 17.9375V8.5625C4.47363 8.1481 4.63727 7.75067 4.92854 7.45765C5.21981 7.16462 5.61486 7 6.02678 7H12.5298"
			stroke="white"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M19.847 4.08009C19.7902 4.01737 19.7214 3.96688 19.6448 3.93166C19.5681 3.89644 19.4851 3.87723 19.4008 3.87518C19.3166 3.87314 19.2327 3.8883 19.1545 3.91976C19.0762 3.95122 19.0051 3.99832 18.9454 4.05821L18.4651 4.53907C18.4069 4.59767 18.3742 4.67713 18.3742 4.75997C18.3742 4.84282 18.4069 4.92227 18.4651 4.98087L18.9054 5.42306C18.9342 5.45223 18.9686 5.47538 19.0063 5.49118C19.0441 5.50697 19.0846 5.5151 19.1255 5.5151C19.1665 5.5151 19.207 5.50697 19.2447 5.49118C19.2825 5.47538 19.3168 5.45223 19.3457 5.42306L19.814 4.95431C20.0508 4.71642 20.073 4.32892 19.847 4.08009ZM17.494 5.51564L10.4846 12.5547C10.4421 12.5973 10.4112 12.6501 10.3949 12.7082L10.0707 13.6797C10.0629 13.7061 10.0624 13.734 10.0691 13.7607C10.0758 13.7873 10.0896 13.8117 10.1089 13.8311C10.1282 13.8505 10.1524 13.8644 10.1789 13.8711C10.2054 13.8779 10.2332 13.8774 10.2594 13.8695L11.2243 13.5434C11.282 13.527 11.3346 13.4959 11.3769 13.4531L18.3738 6.40079C18.4386 6.33497 18.4749 6.24612 18.4749 6.15353C18.4749 6.06094 18.4386 5.97208 18.3738 5.90626L17.9875 5.51564C17.922 5.44992 17.8332 5.41302 17.7407 5.41302C17.6482 5.41302 17.5595 5.44992 17.494 5.51564Z"
			fill="white"
		/>
	</svg>
);

export const DeleteIcon = ({ onClick }) => (
	<svg
		width="25"
		height="24"
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		onClick={onClick}
	>
		<rect x="0.801758" width="23.8563" height="24" rx="4" fill="#FB1A1A" />
		<path
			d="M7.13867 6.375L7.91524 18.875C7.95213 19.5973 8.47438 20.125 9.15776 20.125H16.3022C16.9883 20.125 17.5009 19.5973 17.5447 18.875L18.3213 6.375"
			stroke="white"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path d="M5.89648 6.375H19.5641H5.89648Z" fill="white" />
		<path
			d="M5.89648 6.375H19.5641"
			stroke="white"
			stroke-miterlimit="10"
			stroke-linecap="round"
		/>
		<path
			d="M10.2452 6.375V4.8125C10.2448 4.68929 10.2687 4.56722 10.3154 4.45331C10.3621 4.33941 10.4307 4.23591 10.5173 4.14879C10.6039 4.06166 10.7068 3.99262 10.82 3.94563C10.9333 3.89865 11.0546 3.87464 11.1771 3.875H14.2834C14.4059 3.87464 14.5272 3.89865 14.6404 3.94563C14.7536 3.99262 14.8565 4.06166 14.9431 4.14879C15.0297 4.23591 15.0983 4.33941 15.1451 4.45331C15.1918 4.56722 15.2156 4.68929 15.2153 4.8125V6.375M12.7302 8.875V17.625M9.93457 8.875L10.2452 17.625M15.5259 8.875L15.2153 17.625"
			stroke="white"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

export const PublishIcon = ({ onClick }) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		onClick={onClick}
	>
		<path
			d="M13.5 19.5H19.629L17.6895 21.4395L18.75 22.5L22.5 18.75L18.75 15L17.6895 16.0605L19.629 18H13.5V19.5ZM7.5 15.75H11.25V17.25H7.5V15.75ZM7.5 12H15V13.5H7.5V12Z"
			fill="#04097B"
		/>
		<path
			d="M18.525 6.975L13.275 1.725C13.125 1.575 12.975 1.5 12.75 1.5H5.25C4.425 1.5 3.75 2.175 3.75 3V21C3.75 21.8272 4.4235 22.5 5.25 22.5H11.25V21H5.25V3H11.25V7.5C11.25 8.325 11.925 9 12.75 9H17.25V13.5H18.75V7.5C18.75 7.275 18.675 7.125 18.525 6.975ZM12.75 7.5V3.3L16.95 7.5H12.75Z"
			fill="#04097B"
		/>
	</svg>
);

export const CheckIcon = ({ onClick }) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M7.30356 16.1149L2 10.7502L4.35844 8.36464L7.30356 11.3521L15.5523 3L17.9107 5.3856L7.30356 16.1149Z"
			fill="#F9A910"
		/>
	</svg>
);

export const AddIcon = ({ onClick }) => (
	<svg
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M13.3628 7.63587H7.63587V13.3628H5.7269V7.63587H0V5.7269H5.7269V0H7.63587V5.7269H13.3628V7.63587Z"
			fill="#152238"
		/>
	</svg>
);

export const PhoneIcon = () => (
	<svg
		width="48"
		height="48"
		viewBox="0 0 48 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle cx="24" cy="24" r="23.5" fill="#030659" />
		<circle cx="24" cy="24" r="23.5" stroke="#152238" />
		<circle cx="24" cy="24" r="23.5" stroke="black" stroke-opacity="0.2" />
		<circle cx="24" cy="24" r="23.5" stroke="black" stroke-opacity="0.2" />
		<path
			d="M26.8793 13.9315C26.9268 13.7577 27.0407 13.6096 27.1965 13.5191C27.3522 13.4286 27.5373 13.403 27.7118 13.4478C29.3514 13.8884 30.8463 14.7523 32.0468 15.9528C33.2473 17.1533 34.1111 18.6482 34.5518 20.2878C34.5755 20.3742 34.5818 20.4645 34.5702 20.5534C34.5587 20.6422 34.5295 20.7279 34.4845 20.8054C34.4394 20.8829 34.3794 20.9507 34.3079 21.0047C34.2364 21.0588 34.1549 21.0981 34.0681 21.1203L33.8993 21.1428C33.7499 21.1425 33.6047 21.0927 33.4866 21.0011C33.3685 20.9094 33.2842 20.7812 33.2468 20.6365C32.8653 19.2274 32.1214 17.9428 31.0891 16.9105C30.0568 15.8782 28.7722 15.1343 27.3631 14.7528C27.1918 14.7052 27.0456 14.593 26.9554 14.4398C26.8651 14.2866 26.8379 14.1044 26.8793 13.9315ZM26.4293 18.229C27.2285 18.4478 27.9569 18.8709 28.5427 19.4568C29.1286 20.0427 29.5518 20.7711 29.7706 21.5703C29.8079 21.715 29.8923 21.8432 30.0104 21.9348C30.1284 22.0264 30.2736 22.0763 30.4231 22.0765L30.5918 22.054C30.764 22.004 30.9103 21.8896 31.0004 21.7346C31.0905 21.5796 31.1174 21.3958 31.0756 21.2215C30.7976 20.1919 30.2545 19.2533 29.5004 18.4992C28.7463 17.7451 27.8076 17.202 26.7781 16.924C26.6037 16.8822 26.42 16.9091 26.265 16.9992C26.1099 17.0893 25.9956 17.2356 25.9456 17.4078C25.9011 17.5808 25.927 17.7644 26.0177 17.9184C26.1084 18.0723 26.2564 18.184 26.4293 18.229ZM35.4293 29.2653C35.2407 30.7318 34.5247 32.0795 33.4151 33.0567C32.3054 34.0339 30.8779 34.5737 29.3993 34.5753C20.5906 34.5753 13.4243 27.409 13.4243 18.6003C13.4259 17.1217 13.9657 15.6942 14.9429 14.5845C15.9201 13.4748 17.2678 12.7588 18.7343 12.5703C19.0718 12.5308 19.413 12.6014 19.7069 12.7717C20.0009 12.9421 20.232 13.2029 20.3656 13.5153L22.6268 18.7915C22.7294 19.0302 22.7718 19.2905 22.7502 19.5494C22.7286 19.8084 22.6437 20.058 22.5031 20.2765L20.6243 23.134C20.6057 23.1662 20.5951 23.2024 20.5931 23.2395C20.5911 23.2767 20.598 23.3138 20.6131 23.3478C21.4772 25.1195 22.9114 26.5498 24.6856 27.409C24.72 27.4245 24.7579 27.4305 24.7955 27.4266C24.833 27.4226 24.8688 27.4088 24.8993 27.3865L27.7231 25.5078C27.9394 25.3624 28.1888 25.2739 28.4483 25.2503C28.7078 25.2267 28.9691 25.2688 29.2081 25.3728L34.4843 27.634C34.7967 27.7676 35.0575 27.9986 35.2278 28.2926C35.3981 28.5866 35.4688 28.9278 35.4293 29.2653ZM34.0906 29.0965C34.0944 29.0496 34.0835 29.0027 34.0593 28.9623C34.035 28.9219 33.9988 28.8902 33.9556 28.8715L28.6793 26.6103C28.6444 26.5968 28.6069 26.5919 28.5697 26.5958C28.5326 26.5997 28.4969 26.6124 28.4656 26.6328L25.6531 28.5115C25.4254 28.6611 25.1632 28.7499 24.8914 28.7696C24.6197 28.7893 24.3475 28.7392 24.1006 28.624C22.0542 27.6278 20.3992 25.9767 19.3981 23.9328C19.2812 23.6888 19.2291 23.4188 19.2468 23.1489C19.2645 22.8789 19.3515 22.6181 19.4993 22.3915L21.3668 19.534C21.3891 19.5035 21.4029 19.4677 21.4069 19.4302C21.4108 19.3926 21.4048 19.3547 21.3893 19.3203L19.1281 14.044C19.1108 14.0045 19.0825 13.9707 19.0466 13.9468C19.0107 13.9228 18.9687 13.9097 18.9256 13.909H18.9031C17.7636 14.0588 16.7172 14.6168 15.9579 15.4795C15.1987 16.3422 14.7781 17.451 14.7743 18.6003C14.7773 22.4781 16.3191 26.1963 19.0612 28.9384C21.8032 31.6805 25.5214 33.2223 29.3993 33.2253C30.5485 33.2214 31.6574 32.8009 32.5201 32.0416C33.3828 31.2824 33.9408 30.2359 34.0906 29.0965Z"
			fill="white"
		/>
	</svg>
);

export const EmailIcon = () => (
	<svg
		width="48"
		height="48"
		viewBox="0 0 48 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle cx="24" cy="24" r="24" fill="#030659" />
		<path
			d="M31.425 14.3999C32.3201 14.3999 33.1785 14.7697 33.8114 15.4281C34.4444 16.0864 34.8 16.9793 34.8 17.9103V29.1436C34.8 30.0746 34.4444 30.9675 33.8114 31.6258C33.1785 32.2841 32.3201 32.654 31.425 32.654H16.575C15.6798 32.654 14.8214 32.2841 14.1885 31.6258C13.5555 30.9675 13.2 30.0746 13.2 29.1436V17.9103C13.2 16.9793 13.5555 16.0864 14.1885 15.4281C14.8214 14.7697 15.6798 14.3999 16.575 14.3999H31.425ZM33.45 19.9618L24.3429 25.5363C24.2568 25.5889 24.1605 25.6209 24.0611 25.6302C23.9616 25.6394 23.8614 25.6255 23.7678 25.5896L23.6571 25.5363L14.55 19.9646V29.1436C14.55 29.7022 14.7633 30.2379 15.1431 30.6329C15.5228 31.0279 16.0379 31.2498 16.575 31.2498H31.425C31.962 31.2498 32.4771 31.0279 32.8568 30.6329C33.2366 30.2379 33.45 29.7022 33.45 29.1436V19.9618ZM31.425 15.8041H16.575C16.0379 15.8041 15.5228 16.026 15.1431 16.421C14.7633 16.816 14.55 17.3517 14.55 17.9103V18.3344L24 24.1167L33.45 18.3315V17.9103C33.45 17.3517 33.2366 16.816 32.8568 16.421C32.4771 16.026 31.962 15.8041 31.425 15.8041Z"
			fill="white"
		/>
	</svg>
);

export const Email = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M15.5 4C16.163 4 16.7989 4.26339 17.2678 4.73223C17.7366 5.20107 18 5.83696 18 6.5V14.5C18 15.163 17.7366 15.7989 17.2678 16.2678C16.7989 16.7366 16.163 17 15.5 17H4.5C3.83696 17 3.20107 16.7366 2.73223 16.2678C2.26339 15.7989 2 15.163 2 14.5V6.5C2 5.83696 2.26339 5.20107 2.73223 4.73223C3.20107 4.26339 3.83696 4 4.5 4H15.5ZM17 7.961L10.254 11.931C10.1902 11.9684 10.1189 11.9913 10.0453 11.9978C9.9716 12.0044 9.8974 11.9946 9.828 11.969L9.746 11.931L3 7.963V14.5C3 14.8978 3.15804 15.2794 3.43934 15.5607C3.72064 15.842 4.10218 16 4.5 16H15.5C15.8978 16 16.2794 15.842 16.5607 15.5607C16.842 15.2794 17 14.8978 17 14.5V7.961ZM15.5 5H4.5C4.10218 5 3.72064 5.15804 3.43934 5.43934C3.15804 5.72064 3 6.10218 3 6.5V6.802L10 10.92L17 6.8V6.5C17 6.10218 16.842 5.72064 16.5607 5.43934C16.2794 5.15804 15.8978 5 15.5 5Z"
			fill="#D3D3D3"
		/>
	</svg>
);

export const Quote = () => (
	<svg width="68" height="51" viewBox="0 0 68 51" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M16.8 50.2C13.6 50.2 10.7333 49.4 8.2 47.8C5.8 46.2 3.93333 44 2.6 41.2C1.26667 38.2667 0.600001 34.8667 0.600001 31C0.600001 27.6667 1.13333 24.5333 2.2 21.6C3.26667 18.5333 4.8 15.7333 6.8 13.2C8.93333 10.5333 11.4667 8.13332 14.4 5.99999C17.4667 3.73333 20.9333 1.79999 24.8 0.199997L30.2 7.39999C25.8 9.66666 22.2667 12.2 19.6 15C16.9333 17.8 15.6 20.4667 15.6 23C15.6 24.7333 16.0667 26.2667 17 27.6C17.9333 28.9333 19.2667 30.3333 21 31.8C23.1333 33.4 24.6 34.9333 25.4 36.4C26.3333 37.8667 26.8 39.4 26.8 41C26.8 43.8 25.8667 46.0667 24 47.8C22.2667 49.4 19.8667 50.2 16.8 50.2ZM54 50.2C50.8 50.2 47.9333 49.4 45.4 47.8C43 46.2 41.1333 44 39.8 41.2C38.4667 38.2667 37.8 34.8667 37.8 31C37.8 27.6667 38.3333 24.5333 39.4 21.6C40.4667 18.5333 42 15.7333 44 13.2C46.1333 10.5333 48.6667 8.13332 51.6 5.99999C54.6667 3.73333 58.1333 1.79999 62 0.199997L67.4 7.39999C63 9.66666 59.4667 12.2 56.8 15C54.1333 17.8 52.8 20.4667 52.8 23C52.8 24.7333 53.2667 26.2667 54.2 27.6C55.1333 28.9333 56.4667 30.3333 58.2 31.8C60.3333 33.4 61.8 34.9333 62.6 36.4C63.5333 37.8667 64 39.4 64 41C64 43.8 63.0667 46.0667 61.2 47.8C59.4667 49.4 57.0667 50.2 54 50.2Z" fill="#04097B" />
	</svg>
)

export const MatchesIcon = () => (
	<svg
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M2.125 14.625C1.87777 14.625 1.6361 14.6983 1.43054 14.8357C1.22498 14.973 1.06476 15.1682 0.970151 15.3966C0.875542 15.6251 0.850787 15.8764 0.899019 16.1189C0.94725 16.3613 1.0663 16.5841 1.24112 16.7589C1.41593 16.9337 1.63866 17.0527 1.88114 17.101C2.12361 17.1492 2.37495 17.1245 2.60335 17.0299C2.83176 16.9352 3.02699 16.775 3.16434 16.5695C3.30169 16.3639 3.375 16.1222 3.375 15.875C3.37401 15.5438 3.242 15.2264 3.00779 14.9922C2.77358 14.758 2.45622 14.626 2.125 14.625ZM9 14.625C8.75277 14.625 8.5111 14.6983 8.30554 14.8357C8.09998 14.973 7.93976 15.1682 7.84515 15.3966C7.75054 15.6251 7.72579 15.8764 7.77402 16.1189C7.82225 16.3613 7.9413 16.5841 8.11612 16.7589C8.29093 16.9337 8.51366 17.0527 8.75614 17.101C8.99861 17.1492 9.24995 17.1245 9.47836 17.0299C9.70676 16.9352 9.90199 16.775 10.0393 16.5695C10.1767 16.3639 10.25 16.1222 10.25 15.875C10.249 15.5438 10.117 15.2264 9.88279 14.9922C9.64859 14.758 9.33122 14.626 9 14.625ZM15.875 14.625C15.6278 14.625 15.3861 14.6983 15.1805 14.8357C14.975 14.973 14.8148 15.1682 14.7201 15.3966C14.6255 15.6251 14.6008 15.8764 14.649 16.1189C14.6972 16.3613 14.8163 16.5841 14.9911 16.7589C15.1659 16.9337 15.3887 17.0527 15.6311 17.101C15.8736 17.1492 16.1249 17.1245 16.3534 17.0299C16.5818 16.9352 16.777 16.775 16.9143 16.5695C17.0517 16.3639 17.125 16.1222 17.125 15.875C17.124 15.5438 16.992 15.2264 16.7578 14.9922C16.5236 14.758 16.2062 14.626 15.875 14.625ZM16.5 13.375H15.25V5.875C15.249 5.54378 15.117 5.22642 14.8828 4.99221C14.6486 4.758 14.3312 4.62599 14 4.625H12.75V3.375H14C14.6625 3.37665 15.2975 3.64057 15.7659 4.10906C16.2344 4.57754 16.4984 5.21247 16.5 5.875V13.375ZM8.375 6.5H9.625V13.375H8.375V6.5ZM2.75 13.375H1.5V5.875C1.50165 5.21247 1.76557 4.57754 2.23406 4.10906C2.70254 3.64057 3.33747 3.37665 4 3.375H5.25V4.625H4C3.66878 4.62599 3.35142 4.758 3.11721 4.99221C2.883 5.22642 2.75099 5.54378 2.75 5.875V13.375ZM9 0.25L8.1875 1.89625L6.37125 2.15875L7.68563 3.44125L7.375 5.25L9 4.39625L10.625 5.25L10.3144 3.44125L11.6287 2.16063L9.8125 1.89625L9 0.25Z"
			fill="black"
		/>
	</svg>
);

export const ShortlistIcon = () => (
	<svg
		width="20"
		height="18"
		viewBox="0 0 20 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M2.34375 16V2V6.475V6V16ZM4.34375 10H9.86875C9.90208 9.63333 9.98542 9.28333 10.1187 8.95C10.2521 8.61667 10.4187 8.3 10.6187 8H4.34375V10ZM4.34375 14H8.26875C8.55208 13.6667 8.87708 13.396 9.24375 13.188C9.61042 12.98 9.99375 12.809 10.3938 12.675C10.3271 12.575 10.2688 12.4667 10.2188 12.35C10.1687 12.2333 10.1271 12.1167 10.0938 12H4.34375V14ZM4.34375 6H14.3438V4H4.34375V6ZM2.34375 18C1.79375 18 1.32308 17.8043 0.93175 17.413C0.540417 17.0217 0.344417 16.5507 0.34375 16V2C0.34375 1.45 0.53975 0.979333 0.93175 0.588C1.32375 0.196667 1.79442 0.000666667 2.34375 0H16.3438C16.8937 0 17.3647 0.196 17.7568 0.588C18.1488 0.98 18.3444 1.45067 18.3438 2V8.45C18.1104 8.01667 17.8271 7.63333 17.4937 7.3C17.1604 6.96667 16.7771 6.69167 16.3438 6.475V2H2.34375V16H7.39375C7.37708 16.1 7.36442 16.2 7.35575 16.3C7.34708 16.4 7.34308 16.5 7.34375 16.6V18H2.34375ZM14.3438 13C13.6438 13 13.0521 12.7583 12.5688 12.275C12.0854 11.7917 11.8438 11.2 11.8438 10.5C11.8438 9.8 12.0854 9.20833 12.5688 8.725C13.0521 8.24167 13.6438 8 14.3438 8C15.0437 8 15.6354 8.24167 16.1187 8.725C16.6021 9.20833 16.8438 9.8 16.8438 10.5C16.8438 11.2 16.6021 11.7917 16.1187 12.275C15.6354 12.7583 15.0437 13 14.3438 13ZM9.34375 18V16.6C9.34375 16.2 9.44808 15.8293 9.65675 15.488C9.86542 15.1467 10.1611 14.9007 10.5437 14.75C11.1438 14.5 11.7647 14.3127 12.4067 14.188C13.0487 14.0633 13.6944 14.0007 14.3438 14C14.9931 13.9993 15.6391 14.062 16.2817 14.188C16.9244 14.314 17.5451 14.5013 18.1437 14.75C18.5271 14.9 18.8231 15.146 19.0317 15.488C19.2404 15.83 19.3444 16.2007 19.3438 16.6V18H9.34375Z"
			fill="black"
		/>
	</svg>
);
export const CompleteIcon = () => (
	<svg
		width="24"
		height="25"
		viewBox="0 0 24 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_12115_15903)">
			<path
				d="M12 0.5C13.1016 0.5 14.1641 0.640625 15.1875 0.921875C16.2109 1.20312 17.1641 1.60938 18.0469 2.14062C18.9297 2.67188 19.7383 3.29688 20.4727 4.01562C21.207 4.73438 21.8359 5.54297 22.3594 6.44141C22.8828 7.33984 23.2852 8.29688 23.5664 9.3125C23.8477 10.3281 23.9922 11.3906 24 12.5C24 13.6016 23.8594 14.6641 23.5781 15.6875C23.2969 16.7109 22.8906 17.6641 22.3594 18.5469C21.8281 19.4297 21.2031 20.2383 20.4844 20.9727C19.7656 21.707 18.957 22.3359 18.0586 22.8594C17.1602 23.3828 16.2031 23.7852 15.1875 24.0664C14.1719 24.3477 13.1094 24.4922 12 24.5C10.8984 24.5 9.83594 24.3594 8.8125 24.0781C7.78906 23.7969 6.83594 23.3906 5.95312 22.8594C5.07031 22.3281 4.26172 21.7031 3.52734 20.9844C2.79297 20.2656 2.16406 19.457 1.64062 18.5586C1.11719 17.6602 0.714844 16.7031 0.433594 15.6875C0.152344 14.6719 0.0078125 13.6094 0 12.5C0 11.3984 0.140625 10.3359 0.421875 9.3125C0.703125 8.28906 1.10938 7.33594 1.64062 6.45312C2.17188 5.57031 2.79688 4.76172 3.51562 4.02734C4.23438 3.29297 5.04297 2.66406 5.94141 2.14062C6.83984 1.61719 7.79688 1.21484 8.8125 0.933594C9.82812 0.652344 10.8906 0.507812 12 0.5ZM19.0664 8.52734L17.4727 6.93359L9.75 14.6562L6.52734 11.4336L4.93359 13.0273L9.75 17.8438L19.0664 8.52734Z"
				fill="#009A49"
			/>
		</g>
		<defs>
			<clipPath id="clip0_12115_15903">
				<rect
					width="24"
					height="24"
					fill="white"
					transform="translate(0 0.5)"
				/>
			</clipPath>
		</defs>
	</svg>
);
export const EyeCloseIcon = () => (
	<svg
		width="30"
		height="31"
		viewBox="0 0 30 31"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M25.6624 6.16255C25.8281 5.98483 25.9182 5.74978 25.9139 5.5069C25.9096 5.26402 25.8112 5.03229 25.6395 4.86053C25.4677 4.68876 25.236 4.59037 24.9931 4.58608C24.7502 4.5818 24.5152 4.67195 24.3374 4.83755L4.33745 24.8376C4.24534 24.9234 4.17146 25.0269 4.12022 25.1419C4.06898 25.2569 4.04143 25.381 4.03921 25.5069C4.03699 25.6328 4.06014 25.7578 4.10729 25.8745C4.15445 25.9913 4.22463 26.0973 4.31365 26.1864C4.40267 26.2754 4.50872 26.3456 4.62545 26.3927C4.74219 26.4399 4.86722 26.463 4.9931 26.4608C5.11898 26.4586 5.24312 26.431 5.35812 26.3798C5.47312 26.3285 5.57662 26.2547 5.66245 26.1626L9.4562 22.3688C11.1037 23.1288 12.9899 23.6251 14.9999 23.6251C18.2724 23.6251 21.2149 22.3113 23.3349 20.6838C24.3974 19.8688 25.2687 18.9638 25.8787 18.0838C26.4787 17.2188 26.8749 16.3113 26.8749 15.5001C26.8749 14.6888 26.4787 13.7813 25.8787 12.9176C25.2687 12.0363 24.3974 11.1313 23.3349 10.3176C22.9966 10.0567 22.6383 9.8063 22.2599 9.5663L25.6624 6.16255ZM18.9124 12.9151L17.5374 14.2876C17.7881 14.8124 17.8699 15.402 17.7715 15.9752C17.6732 16.5485 17.3995 17.0771 16.9883 17.4884C16.577 17.8996 16.0484 18.1733 15.4751 18.2716C14.9019 18.37 14.3123 18.2882 13.7874 18.0376L12.4124 19.4126C13.3139 20.0094 14.3939 20.2763 15.4695 20.1681C16.5452 20.0598 17.5504 19.5831 18.3148 18.8187C19.0793 18.0542 19.556 17.049 19.6642 15.9734C19.7724 14.8977 19.5055 13.8177 18.9087 12.9163"
			fill="#FB1A1A"
		/>
		<path
			d="M15.8375 10.8875C15.8889 10.8971 15.9419 10.8942 15.992 10.879C16.042 10.8637 16.0877 10.8366 16.125 10.8L18.5625 8.3625C18.6004 8.32523 18.6278 8.27867 18.6421 8.22748C18.6564 8.17628 18.657 8.12223 18.6438 8.07074C18.6306 8.01925 18.6042 7.97211 18.5671 7.93403C18.53 7.89595 18.4836 7.86827 18.4325 7.85375C17.3155 7.53868 16.1606 7.37761 15 7.375C11.7275 7.375 8.785 8.68875 6.665 10.3163C5.6025 11.1313 4.73125 12.0362 4.12 12.9162C3.52 13.7812 3.125 14.6887 3.125 15.5C3.125 16.3112 3.52125 17.2188 4.12 18.0825C4.71497 18.9172 5.41773 19.6696 6.21 20.32C6.26929 20.369 6.34481 20.394 6.42163 20.3901C6.49846 20.3861 6.57102 20.3536 6.625 20.2987L10.3 16.6238C10.3366 16.5864 10.3637 16.5408 10.379 16.4907C10.3942 16.4407 10.3971 16.3877 10.3875 16.3362C10.3375 16.0654 10.3125 15.7867 10.3125 15.5C10.3124 14.8135 10.4632 14.1353 10.7541 13.5134C11.045 12.8916 11.4689 12.3412 11.9959 11.9012C12.523 11.4612 13.1402 11.1424 13.804 10.9672C14.4678 10.7921 15.162 10.7648 15.8375 10.8875Z"
			fill="#FB1A1A"
		/>
	</svg>
);

export const DashCircleIcon = () => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_4210_7859)">
			<path
				d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z"
				fill="#FB1A1A"
			/>
			<path
				d="M4 8C4 7.86739 4.05268 7.74021 4.14645 7.64645C4.24021 7.55268 4.36739 7.5 4.5 7.5H11.5C11.6326 7.5 11.7598 7.55268 11.8536 7.64645C11.9473 7.74021 12 7.86739 12 8C12 8.13261 11.9473 8.25979 11.8536 8.35355C11.7598 8.44732 11.6326 8.5 11.5 8.5H4.5C4.36739 8.5 4.24021 8.44732 4.14645 8.35355C4.05268 8.25979 4 8.13261 4 8Z"
				fill="#FB1A1A"
			/>
		</g>
		<defs>
			<clipPath id="clip0_4210_7859">
				<rect width="16" height="16" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
export const ShareIcon = ({ onClick }) =>
	(
	  <svg
		width="29"
		height="27"
		viewBox="0 0 29 27"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		onClick={onClick}
	  >
		<rect x="0.5" y="0.5" width="28" height="26" stroke="black" />
		<path
		  d="M19.1415 16.4339C18.6804 16.4337 18.2244 16.531 17.8035 16.7194C17.3827 16.9078 17.0064 17.1831 16.6994 17.5272L12.4797 14.815C12.6618 14.4005 12.7558 13.9527 12.7558 13.4999C12.7558 13.0472 12.6618 12.5994 12.4797 12.1848L16.6994 9.47266C17.2499 10.0867 18.0116 10.4708 18.8327 10.5484C19.6537 10.6259 20.4739 10.3912 21.1296 9.89107C21.7854 9.39093 22.2286 8.66205 22.3709 7.84972C22.5133 7.03738 22.3443 6.20124 21.8976 5.50793C21.451 4.81463 20.7595 4.31507 19.961 4.10883C19.1625 3.90259 18.3156 4.00481 17.5891 4.39512C16.8626 4.78543 16.3098 5.43516 16.041 6.21482C15.7722 6.99449 15.807 7.84682 16.1385 8.60196L11.9188 11.3141C11.4761 10.8191 10.8935 10.4701 10.2481 10.3134C9.60274 10.1567 8.92498 10.1997 8.30455 10.4366C7.68412 10.6735 7.15026 11.0933 6.77362 11.6403C6.39698 12.1873 6.19531 12.8358 6.19531 13.4999C6.19531 14.1641 6.39698 14.8126 6.77362 15.3596C7.15026 15.9066 7.68412 16.3263 8.30455 16.5633C8.92498 16.8002 9.60274 16.8432 10.2481 16.6865C10.8935 16.5298 11.4761 16.1808 11.9188 15.6857L16.1385 18.3979C15.8552 19.0449 15.7885 19.7661 15.9481 20.4542C16.1078 21.1422 16.4853 21.7603 17.0246 22.2165C17.5638 22.6727 18.2359 22.9425 18.9409 22.9859C19.6459 23.0293 20.3461 22.8439 20.9372 22.4573C21.5283 22.0707 21.9788 21.5036 22.2216 20.8403C22.4644 20.177 22.4866 19.4531 22.2848 18.7762C22.083 18.0993 21.6681 17.5057 21.1017 17.0836C20.5353 16.6616 19.8478 16.4337 19.1415 16.4339ZM19.1415 5.04326C19.5852 5.04326 20.019 5.17484 20.388 5.42137C20.7569 5.6679 21.0445 6.01831 21.2143 6.42827C21.3841 6.83824 21.4286 7.28935 21.342 7.72457C21.2554 8.15979 21.0417 8.55956 20.728 8.87333C20.4142 9.18711 20.0144 9.40079 19.5792 9.48736C19.144 9.57393 18.6929 9.5295 18.2829 9.35969C17.8729 9.18987 17.5225 8.90231 17.276 8.53335C17.0295 8.16439 16.8979 7.73061 16.8979 7.28686C16.8979 6.69182 17.1343 6.12115 17.555 5.70039C17.9758 5.27964 18.5464 5.04326 19.1415 5.04326ZM9.47672 15.7435C9.03298 15.7435 8.5992 15.612 8.23024 15.3654C7.86128 15.1189 7.57371 14.7685 7.4039 14.3585C7.23408 13.9486 7.18965 13.4974 7.27622 13.0622C7.36279 12.627 7.57647 12.2272 7.89025 11.9135C8.20402 11.5997 8.6038 11.386 9.03901 11.2994C9.47423 11.2129 9.92534 11.2573 10.3353 11.4271C10.7453 11.5969 11.0957 11.8845 11.3422 12.2535C11.5887 12.6224 11.7203 13.0562 11.7203 13.4999C11.7203 14.095 11.4839 14.6656 11.0632 15.0864C10.6424 15.5072 10.0718 15.7435 9.47672 15.7435ZM19.1415 21.9566C18.6977 21.9566 18.264 21.825 17.895 21.5785C17.526 21.332 17.2385 20.9816 17.0687 20.5716C16.8989 20.1616 16.8544 19.7105 16.941 19.2753C17.0276 18.8401 17.2412 18.4403 17.555 18.1265C17.8688 17.8128 18.2686 17.5991 18.7038 17.5125C19.139 17.4259 19.5901 17.4704 20.0001 17.6402C20.41 17.81 20.7605 18.0976 21.007 18.4665C21.2535 18.8355 21.3851 19.2693 21.3851 19.713C21.3851 20.0076 21.3271 20.2994 21.2143 20.5716C21.1016 20.8438 20.9363 21.0911 20.728 21.2995C20.5196 21.5078 20.2723 21.6731 20.0001 21.7858C19.7279 21.8986 19.4361 21.9566 19.1415 21.9566Z"
		  fill="black"
		/>
	  </svg>
);
export const FbIcon = ({ onClick, color }) => (
	<svg
	width="14"
	height="14"
	viewBox="0 0 14 14"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	onClick={onClick}
	>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M9.15 13.3333V8.17H10.8833L11.1427 6.158H9.14933V4.87333C9.14933 4.29067 9.31133 3.89333 10.1473 3.89333H11.2127V2.09333C10.6968 2.0379 10.1782 2.01119 9.65933 2.01333C8.12333 2.01333 7.072 2.95133 7.072 4.67333V6.158H5.33333V8.17H7.07133V13.3333H0.736C0.329333 13.3333 0 13.004 0 12.5973V0.736C0 0.329333 0.329333 0 0.736 0H12.5973C13.004 0 13.3333 0.329333 13.3333 0.736V12.5973C13.3333 13.004 13.004 13.3333 12.5973 13.3333H9.15Z"
		fill={color || "#929292"}
	/>
	</svg>
);
export const LinkedInIcon = ({ onClick, color }) => (
	<svg
	width="14"
	height="14"
	viewBox="0 0 14 14"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	onClick={onClick}
	>
	<path
		d="M0 1.00275C0 0.448875 0.46025 0 1.02812 0H12.9719C13.5398 0 14 0.448875 14 1.00275V12.9972C14 13.5511 13.5398 14 12.9719 14H1.02812C0.46025 14 0 13.5511 0 12.9972V1.00275ZM4.32512 11.7198V5.39788H2.22425V11.7198H4.32512ZM3.27513 4.53425C4.0075 4.53425 4.46338 4.0495 4.46338 3.44225C4.45025 2.82188 4.00838 2.35025 3.28912 2.35025C2.56988 2.35025 2.1 2.82275 2.1 3.44225C2.1 4.0495 2.55588 4.53425 3.26113 4.53425H3.27513ZM7.56962 11.7198V8.18913C7.56962 8.00012 7.58362 7.81112 7.63963 7.67637C7.791 7.29925 8.13663 6.90812 8.71763 6.90812C9.478 6.90812 9.78162 7.48738 9.78162 8.33788V11.7198H11.8825V8.09375C11.8825 6.15125 10.8465 5.24825 9.464 5.24825C8.34925 5.24825 7.84963 5.86075 7.56962 6.29212V6.314H7.55562L7.56962 6.29212V5.39788H5.46962C5.49587 5.99113 5.46962 11.7198 5.46962 11.7198H7.56962Z"
		fill={color || "#929292"}
	/>
	</svg>
);
export const XIcon = ({ onClick, color }) => (
	<svg
	  width="14"
	  height="14"
	  viewBox="0 0 14 14"
	  fill="none"
	  xmlns="http://www.w3.org/2000/svg"
	  onClick={onClick}
	>
	  <path
		d="M8.13303 6.062L12.5632 0.875H11.5132L7.66753 5.37862L4.59453 0.875H1.05078L5.69703 7.686L1.05078 13.125H2.10078L6.16253 8.3685L9.40791 13.125H12.9517L8.13303 6.062ZM6.69541 7.7455L6.22466 7.06737L2.47878 1.67125H4.09141L7.11366 6.02612L7.58441 6.70425L11.514 12.3655H9.90141L6.69541 7.7455Z"
		fill={color || "#D3D3D3"}
	  />
	</svg>
);
export const WhatsappIcon = ({ onClick, color }) => (
	<svg
	width="16"
	height="16"
	viewBox="0 0 16 16"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	onClick={onClick}
	>
	<path
		d="M8.02719 1.33329C4.38719 1.33329 1.42052 4.29995 1.42052 7.93995C1.42052 9.10662 1.72719 10.24 2.30052 11.24L1.36719 14.6666L4.86719 13.7466C5.83385 14.2733 6.92052 14.5533 8.02719 14.5533C11.6672 14.5533 14.6339 11.5866 14.6339 7.94662C14.6339 6.17995 13.9472 4.51995 12.7005 3.27329C12.0892 2.65603 11.3612 2.1666 10.5589 1.83353C9.75652 1.50046 8.89591 1.33041 8.02719 1.33329ZM8.03385 2.44662C9.50052 2.44662 10.8739 3.01995 11.9139 4.05995C12.4241 4.5703 12.8287 5.1763 13.1044 5.84323C13.3801 6.51017 13.5215 7.22495 13.5205 7.94662C13.5205 10.9733 11.0539 13.4333 8.02719 13.4333C7.04052 13.4333 6.07385 13.1733 5.23385 12.6666L5.03385 12.5533L2.95385 13.1L3.50719 11.0733L3.37385 10.86C2.82355 9.98555 2.5323 8.97311 2.53385 7.93995C2.54052 4.91329 5.00052 2.44662 8.03385 2.44662ZM5.68719 4.88662C5.58052 4.88662 5.40052 4.92662 5.24719 5.09329C5.10052 5.25995 4.66719 5.66662 4.66719 6.47329C4.66719 7.28662 5.26052 8.06662 5.33385 8.17995C5.42719 8.29329 6.50719 9.95995 8.16719 10.6666C8.56052 10.8466 8.86719 10.9466 9.10719 11.02C9.50052 11.1466 9.86052 11.1266 10.1472 11.0866C10.4672 11.04 11.1205 10.6866 11.2605 10.3C11.4005 9.91329 11.4005 9.58662 11.3605 9.51329C11.3139 9.44662 11.2072 9.40662 11.0405 9.33329C10.8739 9.23995 10.0605 8.83995 9.91385 8.78662C9.76052 8.73329 9.66719 8.70662 9.54052 8.86662C9.43385 9.03329 9.11385 9.40662 9.02052 9.51329C8.92052 9.62662 8.82719 9.63995 8.66719 9.55995C8.49385 9.47329 7.96052 9.29995 7.33385 8.73995C6.84052 8.29995 6.51385 7.75995 6.41385 7.59329C6.33385 7.43329 6.40719 7.33329 6.48719 7.25995C6.56052 7.18662 6.66719 7.06662 6.73385 6.96662C6.82052 6.87329 6.84719 6.79995 6.90052 6.69329C6.95385 6.57995 6.92719 6.48662 6.88719 6.40662C6.84719 6.33329 6.51385 5.50662 6.37385 5.17995C6.24052 4.85995 6.10719 4.89995 6.00052 4.89329C5.90719 4.89329 5.80052 4.88662 5.68719 4.88662Z"
		fill={color || "#929292"}
	/>
	</svg>
);

export const HomeIcon = () => (
	<svg
	  width="25"
	  height="25"
	  viewBox="0 0 25 25"
	  fill="none"
	  xmlns="http://www.w3.org/2000/svg"
	>
	  <path
		d="M12.7715 4.94527C12.6988 4.87573 12.6021 4.83691 12.5015 4.83691C12.4009 4.83691 12.3041 4.87573 12.2314 4.94527L3.24219 13.5327C3.20401 13.5692 3.17364 13.6131 3.15291 13.6617C3.13218 13.7103 3.12152 13.7626 3.12158 13.8154L3.12012 21.875C3.12012 22.2894 3.28474 22.6868 3.57776 22.9798C3.87079 23.2728 4.26822 23.4375 4.68262 23.4375H9.375C9.5822 23.4375 9.78091 23.3551 9.92743 23.2086C10.0739 23.0621 10.1563 22.8634 10.1563 22.6562V16.0156C10.1563 15.912 10.1974 15.8126 10.2707 15.7394C10.3439 15.6661 10.4433 15.625 10.5469 15.625H14.4531C14.5567 15.625 14.6561 15.6661 14.7293 15.7394C14.8026 15.8126 14.8438 15.912 14.8438 16.0156V22.6562C14.8438 22.8634 14.9261 23.0621 15.0726 23.2086C15.2191 23.3551 15.4178 23.4375 15.625 23.4375H20.3154C20.7298 23.4375 21.1273 23.2728 21.4203 22.9798C21.7133 22.6868 21.8779 22.2894 21.8779 21.875V13.8154C21.878 13.7626 21.8673 13.7103 21.8466 13.6617C21.8259 13.6131 21.7955 13.5692 21.7573 13.5327L12.7715 4.94527Z"
		fill="white"
	  />
	  <path
		d="M23.9702 11.9214L20.3179 8.42725V3.125C20.3179 2.9178 20.2356 2.71909 20.0891 2.57257C19.9426 2.42606 19.7438 2.34375 19.5366 2.34375H17.1929C16.9857 2.34375 16.787 2.42606 16.6405 2.57257C16.4939 2.71909 16.4116 2.9178 16.4116 3.125V4.6875L13.5835 1.9834C13.3189 1.71582 12.9253 1.5625 12.5 1.5625C12.0762 1.5625 11.6836 1.71582 11.419 1.98389L1.03322 11.9204C0.729511 12.2134 0.691425 12.6953 0.967792 13.0127C1.03719 13.0928 1.12217 13.158 1.21755 13.2042C1.31293 13.2504 1.41672 13.2768 1.5226 13.2816C1.62848 13.2864 1.73424 13.2697 1.83344 13.2324C1.93264 13.195 2.02321 13.1379 2.09963 13.0645L12.2315 3.38281C12.3042 3.31327 12.4009 3.27446 12.5015 3.27446C12.6021 3.27446 12.6988 3.31327 12.7715 3.38281L22.9043 13.0645C23.0536 13.2076 23.2535 13.2857 23.4603 13.2817C23.667 13.2777 23.8638 13.1918 24.0073 13.043C24.3071 12.7324 24.2822 12.2197 23.9702 11.9214Z"
		fill="white"
	  />
	</svg>
  );

export const MailIcon = () => (
	<svg
		width="25"
		height="25"
		viewBox="0 0 25 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
		d="M20.833 4.1665H4.16634C3.02051 4.1665 2.09342 5.104 2.09342 6.24984L2.08301 18.7498C2.08301 19.8957 3.02051 20.8332 4.16634 20.8332H20.833C21.9788 20.8332 22.9163 19.8957 22.9163 18.7498V6.24984C22.9163 5.104 21.9788 4.1665 20.833 4.1665ZM20.4163 8.59359L13.0518 13.1978C12.7184 13.4061 12.2809 13.4061 11.9476 13.1978L4.58301 8.59359C4.47856 8.53495 4.38709 8.45573 4.31414 8.36073C4.24119 8.26572 4.18828 8.1569 4.15861 8.04085C4.12893 7.9248 4.12312 7.80394 4.1415 7.68557C4.15989 7.56721 4.20211 7.45381 4.26559 7.35223C4.32908 7.25066 4.41251 7.16302 4.51085 7.09462C4.60918 7.02623 4.72037 6.97849 4.83769 6.95431C4.95501 6.93014 5.07601 6.93001 5.19338 6.95395C5.31074 6.97789 5.42203 7.02539 5.52051 7.09359L12.4997 11.4582L19.4788 7.09359C19.5773 7.02539 19.6886 6.97789 19.806 6.95395C19.9233 6.93001 20.0443 6.93014 20.1617 6.95431C20.279 6.97849 20.3902 7.02623 20.4885 7.09462C20.5868 7.16302 20.6703 7.25066 20.7338 7.35223C20.7972 7.45381 20.8395 7.56721 20.8578 7.68557C20.8762 7.80394 20.8704 7.9248 20.8407 8.04085C20.8111 8.1569 20.7582 8.26572 20.6852 8.36073C20.6123 8.45573 20.5208 8.53495 20.4163 8.59359Z"
		fill="white"
		/>
	</svg>
);

export const PhoneFillIcon = () => (
	<svg
		width="25"
		height="25"
		viewBox="0 0 25 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M17.2421 23.0553C15.7421 23.0001 11.4911 22.4126 7.03899 17.9615C2.58795 13.5094 2.00149 9.25945 1.94524 7.75841C1.86191 5.47091 3.61399 3.24903 5.63795 2.38132C5.88167 2.27608 6.14857 2.23601 6.41246 2.26505C6.67634 2.29408 6.92814 2.39123 7.14316 2.54695C8.80982 3.76153 9.95982 5.59903 10.9473 7.04382C11.1646 7.36125 11.2575 7.74752 11.2083 8.12903C11.1591 8.51054 10.9713 8.86062 10.6807 9.11257L8.64836 10.6219C8.55018 10.6928 8.48106 10.797 8.45386 10.915C8.42666 11.033 8.44321 11.1569 8.50045 11.2636C8.96086 12.1001 9.77961 13.3459 10.7171 14.2834C11.6546 15.2209 12.9598 16.0938 13.8546 16.6063C13.9668 16.6693 14.0989 16.6869 14.2236 16.6555C14.3484 16.6241 14.4564 16.5461 14.5254 16.4376L15.8484 14.424C16.0916 14.101 16.4504 13.8845 16.8496 13.8201C17.2488 13.7556 17.6575 13.8481 17.99 14.0782C19.4557 15.0928 21.1661 16.223 22.4182 17.8261C22.5865 18.0427 22.6936 18.3005 22.7282 18.5726C22.7629 18.8447 22.7238 19.1212 22.615 19.373C21.7432 21.4074 19.5369 23.1397 17.2421 23.0553Z"
		fill="white"
		/>
	</svg>
);
export const WhatsAppIcon = () => (
	<svg
	  width="25"
	  height="25"
	  viewBox="0 0 25 25"
	  fill="none"
	  xmlns="http://www.w3.org/2000/svg"
	>
	  <g clip-path="url(#clip0_13151_8116)">
		<path
		  d="M0.533203 12.3501C0.532617 14.4506 1.08574 16.5016 2.1375 18.3094L0.432617 24.4859L6.80293 22.8285C8.56488 23.7803 10.539 24.279 12.5451 24.2791H12.5504C19.1729 24.2791 24.5639 18.9319 24.5667 12.3595C24.568 9.17476 23.3191 6.17999 21.0502 3.92689C18.7816 1.67398 15.7646 0.432606 12.5499 0.431152C5.92656 0.431152 0.536035 5.77805 0.533301 12.3501"
		  fill="url(#paint0_linear_13151_8116)"
		/>
		<path
		  d="M0.104492 12.3465C0.103809 14.5226 0.676758 16.6469 1.76602 18.5194L0 24.9173L6.59873 23.2006C8.41689 24.1842 10.464 24.7028 12.547 24.7036H12.5523C19.4125 24.7036 24.9971 19.1641 25 12.3564C25.0012 9.05717 23.7074 5.95475 21.3574 3.62093C19.0071 1.2874 15.8821 0.00135659 12.5523 0C5.69101 0 0.107227 5.53876 0.104492 12.3465ZM4.03428 18.1969L3.78789 17.8088C2.75215 16.1747 2.20547 14.2863 2.20625 12.3473C2.2084 6.68886 6.84941 2.08527 12.5563 2.08527C15.3199 2.08643 17.9172 3.15543 19.8707 5.09496C21.8241 7.03469 22.899 9.61318 22.8983 12.3556C22.8958 18.0141 18.2547 22.6182 12.5523 22.6182H12.5482C10.6915 22.6172 8.87051 22.1225 7.28242 21.1875L6.90449 20.9651L2.98867 21.9838L4.03428 18.1969Z"
		  fill="url(#paint1_linear_13151_8116)"
		/>
		<path
		  d="M9.44141 7.18495C9.2084 6.67109 8.96318 6.66072 8.7416 6.65171C8.56016 6.64396 8.35273 6.64454 8.14551 6.64454C7.93809 6.64454 7.60107 6.72196 7.31621 7.03059C7.03105 7.3395 6.22754 8.08601 6.22754 9.60433C6.22754 11.1226 7.34209 12.5901 7.49746 12.7962C7.65303 13.0019 9.64912 16.2174 12.8104 17.4544C15.4378 18.4824 15.9725 18.278 16.5427 18.2264C17.113 18.1751 18.3829 17.4801 18.642 16.7595C18.9013 16.0389 18.9013 15.4213 18.8235 15.2922C18.7458 15.1636 18.5384 15.0864 18.2273 14.9321C17.9163 14.7779 16.3871 14.0312 16.102 13.9282C15.8169 13.8253 15.6096 13.7739 15.4021 14.0829C15.1947 14.3914 14.5991 15.0864 14.4176 15.2922C14.2362 15.4985 14.0547 15.5242 13.7437 15.3698C13.4325 15.215 12.4309 14.8895 11.2425 13.8382C10.3179 13.0202 9.69365 12.01 9.51221 11.701C9.33076 11.3925 9.49277 11.2253 9.64873 11.0715C9.78848 10.9332 9.95986 10.7111 10.1155 10.531C10.2706 10.3507 10.3224 10.2222 10.4261 10.0163C10.5299 9.81034 10.4779 9.6301 10.4003 9.47574C10.3224 9.32138 9.71797 7.79512 9.44141 7.18495Z"
		  fill="white"
		/>
	  </g>
	  <defs>
		<linearGradient
		  id="paint0_linear_13151_8116"
		  x1="1207.14"
		  y1="2405.91"
		  x2="1207.14"
		  y2="0.431152"
		  gradientUnits="userSpaceOnUse"
		>
		  <stop stop-color="#1FAF38" />
		  <stop offset="1" stop-color="#60D669" />
		</linearGradient>
		<linearGradient
		  id="paint1_linear_13151_8116"
		  x1="1250"
		  y1="2491.73"
		  x2="1250"
		  y2="0"
		  gradientUnits="userSpaceOnUse"
		>
		  <stop stop-color="#F9F9F9" />
		  <stop offset="1" stop-color="white" />
		</linearGradient>
		<clipPath id="clip0_13151_8116">
		  <rect width="25" height="25" fill="white" />
		</clipPath>
	  </defs>
	</svg>
);
  
export const FeatureIcon = () => (
	<svg
		width="29"
		height="30"
		viewBox="0 0 29 30"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
		d="M2.8125 3.28125V24.8438C2.8125 25.1025 3.0225 25.3125 3.28125 25.3125H9.225C9.59796 25.3125 9.95565 25.4607 10.2194 25.7244C10.4831 25.9881 10.6313 26.3458 10.6313 26.7188C10.6313 27.0917 10.4831 27.4494 10.2194 27.7131C9.95565 27.9768 9.59796 28.125 9.225 28.125H3.28125C2.41101 28.125 1.57641 27.7793 0.961056 27.1639C0.345702 26.5486 0 25.714 0 24.8438V3.28125C0 1.47 1.47 0 3.28125 0H19.2188C21.03 0 22.5 1.47 22.5 3.28125V17.7863C22.5 18.1592 22.3518 18.5169 22.0881 18.7806C21.8244 19.0443 21.4667 19.1925 21.0938 19.1925C20.7208 19.1925 20.3631 19.0443 20.0994 18.7806C19.8357 18.5169 19.6875 18.1592 19.6875 17.7863V3.28125C19.6875 3.15693 19.6381 3.0377 19.5502 2.94979C19.4623 2.86189 19.3431 2.8125 19.2188 2.8125H3.28125C3.15693 2.8125 3.0377 2.86189 2.94979 2.94979C2.86189 3.0377 2.8125 3.15693 2.8125 3.28125ZM27.7013 21.1631L19.1569 29.5069C18.8916 29.7654 18.5351 29.9088 18.1647 29.906C17.7944 29.9032 17.44 29.7544 17.1787 29.4919L13.5356 25.8356C13.2877 25.5686 13.1531 25.2157 13.1602 24.8514C13.1673 24.4871 13.3156 24.1398 13.5737 23.8826C13.8319 23.6254 14.1798 23.4785 14.5441 23.4728C14.9084 23.467 15.2608 23.603 15.5269 23.8519L18.1875 26.5238L25.7362 19.1512C26.0033 18.8907 26.3629 18.7469 26.736 18.7514C26.9207 18.7537 27.1032 18.7923 27.273 18.8651C27.4428 18.9379 27.5966 19.0434 27.7256 19.1756C27.8546 19.3078 27.9564 19.4642 28.025 19.6357C28.0936 19.8073 28.1277 19.9906 28.1255 20.1754C28.1232 20.3601 28.0846 20.5426 28.0118 20.7124C27.939 20.8822 27.8335 21.036 27.7013 21.165M7.03125 7.5H15.4688C15.8417 7.5 16.1994 7.64816 16.4631 7.91188C16.7268 8.1756 16.875 8.53329 16.875 8.90625C16.875 9.27921 16.7268 9.6369 16.4631 9.90062C16.1994 10.1643 15.8417 10.3125 15.4688 10.3125H7.03125C6.65829 10.3125 6.3006 10.1643 6.03688 9.90062C5.77316 9.6369 5.625 9.27921 5.625 8.90625C5.625 8.53329 5.77316 8.1756 6.03688 7.91188C6.3006 7.64816 6.65829 7.5 7.03125 7.5ZM5.625 14.5312C5.625 14.1583 5.77316 13.8006 6.03688 13.5369C6.3006 13.2732 6.65829 13.125 7.03125 13.125H10.7812C11.1542 13.125 11.5119 13.2732 11.7756 13.5369C12.0393 13.8006 12.1875 14.1583 12.1875 14.5312C12.1875 14.9042 12.0393 15.2619 11.7756 15.5256C11.5119 15.7893 11.1542 15.9375 10.7812 15.9375H7.03125C6.65829 15.9375 6.3006 15.7893 6.03688 15.5256C5.77316 15.2619 5.625 14.9042 5.625 14.5312Z"
		fill="#1FAF38"
		/>
	</svg>
);
  
export const ArrowFullIcon = () => (
	<svg
	  width="48"
	  height="12"
	  viewBox="0 0 48 12"
	  fill="none"
	  xmlns="http://www.w3.org/2000/svg"
	>
	  <path
		d="M48 5.77356L38 5.67436e-05V11.5471L48 5.77356ZM0 5.77356V6.77356H39V5.77356V4.77356H0V5.77356Z"
		fill="black"
	  />
	</svg>
); 


export const MatchTalentIcon = () => (
	<svg
	  width="24"
	  height="24"
	  viewBox="0 0 24 24"
	  fill="none"
	  xmlns="http://www.w3.org/2000/svg"
	>
	  <path
		d="M3 19.0005L8.5 12.0005L3 4.98047H15.462L21 12.0005L20.817 12.2145C20.375 11.9971 19.9187 11.8335 19.448 11.7235C18.9773 11.6135 18.4947 11.5585 18 11.5585C16.1947 11.5585 14.657 12.1808 13.387 13.4255C12.117 14.6701 11.4687 16.1951 11.442 18.0005C11.442 18.1711 11.4477 18.3398 11.459 18.5065C11.4703 18.6731 11.4943 18.8378 11.531 19.0005H3ZM18 22.2895C16.8347 22.2895 15.848 21.8851 15.04 21.0765C14.232 20.2678 13.8277 19.2811 13.827 18.1165C13.8263 16.9518 14.2307 15.9648 15.04 15.1555C15.8493 14.3461 16.836 13.9418 18 13.9425C19.164 13.9431 20.1507 14.3475 20.96 15.1555C21.7693 15.9635 22.1737 16.9501 22.173 18.1155C22.1723 19.2808 21.768 20.2678 20.96 21.0765C20.152 21.8851 19.1653 22.2901 18 22.2895ZM17.371 19.8275L20.211 17.0315L19.585 16.4045L17.371 18.5865L16.416 17.6115L15.789 18.2445L17.371 19.8275Z"
		fill="black"
	  />
	</svg>
  );


export const SubscriptionIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_13964_19330)">
      <path
        d="M22.7309 19.6043L19.6366 20.1992L18.6046 17.2232M1.28516 4.39172L4.36058 3.80029L5.38744 6.76086"
        stroke="white"
        stroke-width="2.14286"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.35887 3.79707C2.35144 5.61936 1.28516 8.39479 1.28516 11.9999C1.28516 18.8571 5.1423 22.7142 11.9994 22.7142C13.6263 22.7142 15.0852 22.4965 16.3623 22.0748M19.6469 20.1959C21.6509 18.3736 22.7137 15.6016 22.7137 11.9999C22.7137 5.14279 18.8566 1.28564 11.9994 1.28564C10.3674 1.28793 8.9103 1.50222 7.62801 1.9285"
        stroke="black"
        stroke-width="2.14286"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.8487 8.89351C14.8487 8.89351 13.779 7.70037 12.0407 7.8478C10.3041 7.99865 9.46582 9.06494 9.46582 10.1364C9.46582 13.2564 14.8487 11.0929 14.8487 14.2952C14.8487 15.9444 11.2778 17.1101 9.15039 15.1695M12.2532 5.74951V7.8358M12.2532 16.1638V18.2501"
        stroke="black"
        stroke-width="2.14286"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_13964_19330">
        <rect width="24" height="24" fill="black" />
      </clipPath>
    </defs>
  </svg>
);
export const SubscriptionIconActive = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_13964_19330)">
      <path
        d="M22.7309 19.6043L19.6366 20.1992L18.6046 17.2232M1.28516 4.39172L4.36058 3.80029L5.38744 6.76086"
        stroke="white"
        stroke-width="2.14286"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.35887 3.79707C2.35144 5.61936 1.28516 8.39479 1.28516 11.9999C1.28516 18.8571 5.1423 22.7142 11.9994 22.7142C13.6263 22.7142 15.0852 22.4965 16.3623 22.0748M19.6469 20.1959C21.6509 18.3736 22.7137 15.6016 22.7137 11.9999C22.7137 5.14279 18.8566 1.28564 11.9994 1.28564C10.3674 1.28793 8.9103 1.50222 7.62801 1.9285"
        stroke="white"
        stroke-width="2.14286"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.8487 8.89351C14.8487 8.89351 13.779 7.70037 12.0407 7.8478C10.3041 7.99865 9.46582 9.06494 9.46582 10.1364C9.46582 13.2564 14.8487 11.0929 14.8487 14.2952C14.8487 15.9444 11.2778 17.1101 9.15039 15.1695M12.2532 5.74951V7.8358M12.2532 16.1638V18.2501"
        stroke="white"
        stroke-width="2.14286"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_13964_19330">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const LongArrow = () => (
	<svg width="87" height="15" viewBox="0 0 87 15" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M86.7071 8.07039C87.0976 7.67986 87.0976 7.0467 86.7071 6.65617L80.3431 0.292213C79.9526 -0.0983109 79.3195 -0.0983109 78.9289 0.292213C78.5384 0.682738 78.5384 1.3159 78.9289 1.70643L84.5858 7.36328L78.9289 13.0201C78.5384 13.4107 78.5384 14.0438 78.9289 14.4343C79.3195 14.8249 79.9526 14.8249 80.3431 14.4343L86.7071 8.07039ZM0 7.36328V8.36328H86V7.36328V6.36328H0V7.36328Z" fill="url(#paint0_linear_14008_19362)"/>
	<defs>
	<linearGradient id="paint0_linear_14008_19362" x1="43" y1="7.36328" x2="43" y2="8.36328" gradientUnits="userSpaceOnUse">
	<stop stop-color="#F9A910"/>
	<stop offset="1" stop-color="#DD9204"/>
	</linearGradient>
	</defs>
	</svg>	
);
export const ShortArrow = () => (
<svg width="24" height="8" viewBox="0 0 24 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.3536 4.03519C23.5488 3.83993 23.5488 3.52335 23.3536 3.32809L20.1716 0.146107C19.9763 -0.0491555 19.6597 -0.0491555 19.4645 0.146107C19.2692 0.341369 19.2692 0.657951 19.4645 0.853214L22.2929 3.68164L19.4645 6.51007C19.2692 6.70533 19.2692 7.02191 19.4645 7.21717C19.6597 7.41244 19.9763 7.41244 20.1716 7.21717L23.3536 4.03519ZM0 3.68164V4.18164H23V3.68164V3.18164H0V3.68164Z" fill="url(#paint0_linear_14642_19837)"/>
<defs>
<linearGradient id="paint0_linear_14642_19837" x1="11.5" y1="3.68164" x2="11.5" y2="4.68164" gradientUnits="userSpaceOnUse">
<stop stop-color="#F9A910"/>
<stop offset="1" stop-color="#DD9204"/>
</linearGradient>
</defs>
</svg>	
);
export const CPUIcon = () => (
  <svg
    width="53"
    height="53"
    viewBox="0 0 53 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36.6875 7.8125H16.0625C11.5062 7.8125 7.8125 11.5062 7.8125 16.0625V36.6875C7.8125 41.2439 11.5062 44.9375 16.0625 44.9375H36.6875C41.2439 44.9375 44.9375 41.2439 44.9375 36.6875V16.0625C44.9375 11.5062 41.2439 7.8125 36.6875 7.8125Z"
      stroke="black"
      stroke-width="1.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M44.9375 17.4375H51.8125M44.9375 26.375H51.8125M44.9375 35.3125H51.8125M35.3125 44.9375V51.8125M26.375 44.9375V51.8125M17.4375 44.9375V51.8125M0.9375 17.4375H7.8125M0.9375 26.375H7.8125M0.9375 35.3125H7.8125M35.3125 0.9375V7.8125M26.375 0.9375V7.8125M17.4375 0.9375V7.8125"
      stroke="black"
      stroke-width="1.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M30.5 19.5H22.25C20.7312 19.5 19.5 20.7312 19.5 22.25V30.5C19.5 32.0188 20.7312 33.25 22.25 33.25H30.5C32.0188 33.25 33.25 32.0188 33.25 30.5V22.25C33.25 20.7312 32.0188 19.5 30.5 19.5Z"
      stroke="black"
      stroke-width="1.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const LightStar = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.49428 14.1925L6.42428 10.2077L3.33203 7.52872L7.40528 7.17622L9.00053 3.41797L10.5958 7.17547L14.6683 7.52797L11.576 10.207L12.5068 14.1917L9.00053 12.0767L5.49428 14.1925Z"
      fill="url(#paint0_linear_14427_8058)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_14427_8058"
        x1="9.00016"
        y1="3.41797"
        x2="9.00016"
        y2="14.1925"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F9A910" />
        <stop offset="1" stop-color="#DD9204" />
      </linearGradient>
    </defs>
  </svg>
);

export const BorderPoint = () => (
  <svg
    width="302"
    height="7"
    viewBox="0 0 302 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="7" y1="3.5" x2="302" y2="3.49997" stroke="black" />
    <circle cx="3.5" cy="3.5" r="3.5" fill="#EB9B01" />
  </svg>
);
export const AiInsightIconActive = () => (
  <svg
    width="20"
    height="23"
    viewBox="0 0 20 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0013 1C9.73605 1 9.4817 1.10536 9.29416 1.29289C9.10662 1.48043 9.00127 1.73478 9.00127 2C9.00127 2.26522 9.10662 2.51957 9.29416 2.70711C9.4817 2.89464 9.73605 3 10.0013 3C10.8163 3.00018 11.6227 3.1664 12.3714 3.48853C13.1201 3.81065 13.7952 4.28193 14.3558 4.87361C14.9163 5.46529 15.3504 6.16496 15.6316 6.92993C15.9128 7.69491 16.0351 8.50916 15.9913 9.323C15.9843 9.473 16.0113 9.623 16.0683 9.761L17.1093 12.258L16.6063 12.359C16.2978 12.421 16.0166 12.5784 15.8025 12.809C15.5884 13.0396 15.4522 13.3317 15.4133 13.644L15.2273 15.124C15.197 15.3658 15.0796 15.5883 14.8969 15.7496C14.7142 15.9109 14.479 15.9999 14.2353 16H12.5013C12.1034 16 11.7219 16.158 11.4406 16.4393C11.1593 16.7206 11.0013 17.1022 11.0013 17.5V19H7.00127V15.006C7.00127 14.509 6.75627 14.069 6.39127 13.794L6.11027 13.567C5.2288 12.8149 4.58269 11.8247 4.24927 10.715C4.1722 10.4625 3.99844 10.2508 3.76589 10.1259C3.53333 10.0011 3.26084 9.97321 3.00783 10.0484C2.75482 10.1237 2.54181 10.2959 2.41526 10.5275C2.28871 10.7592 2.25887 11.0314 2.33227 11.285C2.79893 12.8441 3.73002 14.2238 5.00127 15.24V19.5C5.00127 19.8978 5.1593 20.2794 5.44061 20.5607C5.72191 20.842 6.10344 21 6.50127 21H11.5013C11.8991 21 12.2806 20.842 12.5619 20.5607C12.8432 20.2794 13.0013 19.8978 13.0013 19.5V18H14.2353C14.9665 18 15.6726 17.733 16.2208 17.2491C16.769 16.7651 17.1216 16.0976 17.2123 15.372L17.3533 14.249L18.0983 14.101C18.316 14.0576 18.5213 13.9663 18.6995 13.8339C18.8776 13.7015 19.0242 13.5312 19.1286 13.3353C19.2329 13.1393 19.2925 12.9227 19.303 12.7009C19.3135 12.4792 19.2747 12.2579 19.1893 12.053L17.9963 9.187L18.0013 9C18.0013 6.87827 17.1584 4.84344 15.6581 3.34315C14.1578 1.84286 12.123 1 10.0013 1ZM4.00127 1.80688e-07C3.7925 -0.000125281 3.58893 0.065089 3.4191 0.186499C3.24927 0.307909 3.1217 0.479426 3.05427 0.677L2.92527 1.055C2.62527 1.934 1.93527 2.625 1.05527 2.925L0.677267 3.054C0.480072 3.12157 0.308922 3.24908 0.187748 3.41869C0.0665741 3.58831 0.00143242 3.79155 0.00143242 4C0.00143242 4.20845 0.0665741 4.41169 0.187748 4.58131C0.308922 4.75092 0.480072 4.87843 0.677267 4.946L1.05527 5.076C1.93527 5.376 2.62527 6.066 2.92527 6.946L3.05527 7.323C3.12284 7.5202 3.25035 7.69134 3.41996 7.81252C3.58957 7.93369 3.79282 7.99883 4.00127 7.99883C4.20972 7.99883 4.41296 7.93369 4.58257 7.81252C4.75219 7.69134 4.87969 7.5202 4.94727 7.323L5.07627 6.945C5.22437 6.51114 5.46993 6.11699 5.79409 5.79283C6.11826 5.46866 6.51241 5.2231 6.94627 5.075L7.32427 4.946C7.52146 4.87843 7.69261 4.75092 7.81378 4.58131C7.93496 4.41169 8.0001 4.20845 8.0001 4C8.0001 3.79155 7.93496 3.58831 7.81378 3.41869C7.69261 3.24908 7.52146 3.12157 7.32427 3.054L6.94627 2.924C6.06727 2.624 5.37627 1.934 5.07627 1.054L4.94627 0.677L4.88427 0.531C4.79914 0.370686 4.67198 0.236566 4.51642 0.143022C4.36087 0.0494771 4.18278 3.61528e-05 4.00127 1.80688e-07ZM4.00127 3.196C4.23751 3.49364 4.50692 3.76339 4.80427 4C4.50627 4.23667 4.2386 4.50433 4.00127 4.803C3.76393 4.505 3.49627 4.23733 3.19827 4C3.49562 3.76339 3.76502 3.49364 4.00127 3.196Z"
      fill="white"
    />
  </svg>
);
export const AiInsightIcon = () => (
  <svg
    width="20"
    height="23"
    viewBox="0 0 20 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0013 1C9.73605 1 9.4817 1.10536 9.29416 1.29289C9.10662 1.48043 9.00127 1.73478 9.00127 2C9.00127 2.26522 9.10662 2.51957 9.29416 2.70711C9.4817 2.89464 9.73605 3 10.0013 3C10.8163 3.00018 11.6227 3.1664 12.3714 3.48853C13.1201 3.81065 13.7952 4.28193 14.3558 4.87361C14.9163 5.46529 15.3504 6.16496 15.6316 6.92993C15.9128 7.69491 16.0351 8.50916 15.9913 9.323C15.9843 9.473 16.0113 9.623 16.0683 9.761L17.1093 12.258L16.6063 12.359C16.2978 12.421 16.0166 12.5784 15.8025 12.809C15.5884 13.0396 15.4522 13.3317 15.4133 13.644L15.2273 15.124C15.197 15.3658 15.0796 15.5883 14.8969 15.7496C14.7142 15.9109 14.479 15.9999 14.2353 16H12.5013C12.1034 16 11.7219 16.158 11.4406 16.4393C11.1593 16.7206 11.0013 17.1022 11.0013 17.5V19H7.00127V15.006C7.00127 14.509 6.75627 14.069 6.39127 13.794L6.11027 13.567C5.2288 12.8149 4.58269 11.8247 4.24927 10.715C4.1722 10.4625 3.99844 10.2508 3.76589 10.1259C3.53333 10.0011 3.26084 9.97321 3.00783 10.0484C2.75482 10.1237 2.54181 10.2959 2.41526 10.5275C2.28871 10.7592 2.25887 11.0314 2.33227 11.285C2.79893 12.8441 3.73002 14.2238 5.00127 15.24V19.5C5.00127 19.8978 5.1593 20.2794 5.44061 20.5607C5.72191 20.842 6.10344 21 6.50127 21H11.5013C11.8991 21 12.2806 20.842 12.5619 20.5607C12.8432 20.2794 13.0013 19.8978 13.0013 19.5V18H14.2353C14.9665 18 15.6726 17.733 16.2208 17.2491C16.769 16.7651 17.1216 16.0976 17.2123 15.372L17.3533 14.249L18.0983 14.101C18.316 14.0576 18.5213 13.9663 18.6995 13.8339C18.8776 13.7015 19.0242 13.5312 19.1286 13.3353C19.2329 13.1393 19.2925 12.9227 19.303 12.7009C19.3135 12.4792 19.2747 12.2579 19.1893 12.053L17.9963 9.187L18.0013 9C18.0013 6.87827 17.1584 4.84344 15.6581 3.34315C14.1578 1.84286 12.123 1 10.0013 1ZM4.00127 1.80688e-07C3.7925 -0.000125281 3.58893 0.065089 3.4191 0.186499C3.24927 0.307909 3.1217 0.479426 3.05427 0.677L2.92527 1.055C2.62527 1.934 1.93527 2.625 1.05527 2.925L0.677267 3.054C0.480072 3.12157 0.308922 3.24908 0.187748 3.41869C0.0665741 3.58831 0.00143242 3.79155 0.00143242 4C0.00143242 4.20845 0.0665741 4.41169 0.187748 4.58131C0.308922 4.75092 0.480072 4.87843 0.677267 4.946L1.05527 5.076C1.93527 5.376 2.62527 6.066 2.92527 6.946L3.05527 7.323C3.12284 7.5202 3.25035 7.69134 3.41996 7.81252C3.58957 7.93369 3.79282 7.99883 4.00127 7.99883C4.20972 7.99883 4.41296 7.93369 4.58257 7.81252C4.75219 7.69134 4.87969 7.5202 4.94727 7.323L5.07627 6.945C5.22437 6.51114 5.46993 6.11699 5.79409 5.79283C6.11826 5.46866 6.51241 5.2231 6.94627 5.075L7.32427 4.946C7.52146 4.87843 7.69261 4.75092 7.81378 4.58131C7.93496 4.41169 8.0001 4.20845 8.0001 4C8.0001 3.79155 7.93496 3.58831 7.81378 3.41869C7.69261 3.24908 7.52146 3.12157 7.32427 3.054L6.94627 2.924C6.06727 2.624 5.37627 1.934 5.07627 1.054L4.94627 0.677L4.88427 0.531C4.79914 0.370686 4.67198 0.236566 4.51642 0.143022C4.36087 0.0494771 4.18278 3.61528e-05 4.00127 1.80688e-07ZM4.00127 3.196C4.23751 3.49364 4.50692 3.76339 4.80427 4C4.50627 4.23667 4.2386 4.50433 4.00127 4.803C3.76393 4.505 3.49627 4.23733 3.19827 4C3.49562 3.76339 3.76502 3.49364 4.00127 3.196Z"
      fill="#04097B"
    />
  </svg>
);
export const SchoolIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.9987 2.5L0.832031 7.5L4.16536 9.31667V14.3167L9.9987 17.5L15.832 14.3167V9.31667L17.4987 8.40833V14.1667H19.1654V7.5L9.9987 2.5ZM15.682 7.5L9.9987 10.6L4.31536 7.5L9.9987 4.4L15.682 7.5ZM14.1654 13.325L9.9987 15.6L5.83203 13.325V10.225L9.9987 12.5L14.1654 10.225V13.325Z"
      fill="black"
      fill-opacity="0.3"
    />
  </svg>
);
export const CertificateIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.9375 3.75C0.9375 3.25272 1.13504 2.77581 1.48667 2.42417C1.83831 2.07254 2.31522 1.875 2.8125 1.875H12.1875C12.6848 1.875 13.1617 2.07254 13.5133 2.42417C13.865 2.77581 14.0625 3.25272 14.0625 3.75V9.375C14.0625 9.87228 13.865 10.3492 13.5133 10.7008C13.1617 11.0525 12.6848 11.25 12.1875 11.25H6.5625V10.9181C6.72759 10.7312 6.87362 10.5284 6.99844 10.3125H12.1875C12.4361 10.3125 12.6746 10.2137 12.8504 10.0379C13.0262 9.8621 13.125 9.62364 13.125 9.375V3.75C13.125 3.50136 13.0262 3.2629 12.8504 3.08709C12.6746 2.91127 12.4361 2.8125 12.1875 2.8125H2.8125C2.56386 2.8125 2.3254 2.91127 2.14959 3.08709C1.97377 3.2629 1.875 3.50136 1.875 3.75V5.18906C1.52287 5.39277 1.20623 5.65241 0.9375 5.95781V3.75ZM6.23063 5.625C5.63518 5.09977 4.88838 4.77709 4.09781 4.70344C4.13726 4.69288 4.17792 4.68752 4.21875 4.6875H10.7812C10.9056 4.6875 11.0248 4.73689 11.1127 4.82479C11.2006 4.9127 11.25 5.03193 11.25 5.15625C11.25 5.28057 11.2006 5.3998 11.1127 5.48771C11.0248 5.57561 10.9056 5.625 10.7812 5.625H6.23063ZM7.96875 7.5C7.84443 7.5 7.7252 7.54939 7.63729 7.63729C7.54939 7.7252 7.5 7.84443 7.5 7.96875C7.5 8.09307 7.54939 8.2123 7.63729 8.30021C7.7252 8.38811 7.84443 8.4375 7.96875 8.4375H10.7812C10.9056 8.4375 11.0248 8.38811 11.1127 8.30021C11.2006 8.2123 11.25 8.09307 11.25 7.96875C11.25 7.84443 11.2006 7.7252 11.1127 7.63729C11.0248 7.54939 10.9056 7.5 10.7812 7.5H7.96875ZM6.5625 8.4375C6.5625 8.80684 6.48975 9.17257 6.34841 9.5138C6.20707 9.85503 5.9999 10.1651 5.73874 10.4262C5.47757 10.6874 5.16753 10.8946 4.8263 11.0359C4.48507 11.1773 4.11934 11.25 3.75 11.25C3.38066 11.25 3.01493 11.1773 2.6737 11.0359C2.33247 10.8946 2.02243 10.6874 1.76126 10.4262C1.5001 10.1651 1.29293 9.85503 1.15159 9.5138C1.01025 9.17257 0.9375 8.80684 0.9375 8.4375C0.9375 7.69158 1.23382 6.97621 1.76126 6.44876C2.28871 5.92132 3.00408 5.625 3.75 5.625C4.49592 5.625 5.21129 5.92132 5.73874 6.44876C6.26618 6.97621 6.5625 7.69158 6.5625 8.4375ZM1.875 11.6653V13.5938C1.87497 13.6786 1.89797 13.7619 1.94156 13.8347C1.98515 13.9075 2.04769 13.9671 2.1225 14.0072C2.19737 14.047 2.28164 14.0658 2.36634 14.0615C2.45103 14.0572 2.53298 14.03 2.60344 13.9828L3.75 13.2188L4.89656 13.9838C4.94941 14.0189 5.00884 14.0429 5.07125 14.0544C5.13365 14.0659 5.19774 14.0645 5.25963 14.0505C5.32151 14.0365 5.37991 14.01 5.43127 13.9728C5.48263 13.9355 5.5259 13.8882 5.55844 13.8338C5.60202 13.7609 5.62503 13.6777 5.625 13.5928V11.6653C5.05747 12.0027 4.41023 12.1826 3.75 12.1866C3.08977 12.1826 2.44253 12.0027 1.875 11.6653Z"
      fill="black"
    />
  </svg>
);

export const PersonIllustration = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 400 500"
    preserveAspectRatio="xMidYMid slice"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="tHeroBg" x1="0" x2="1" y1="0" y2="1">
        <stop offset="0%" stopColor="#1B2E5C" />
        <stop offset="100%" stopColor="#0A1F44" />
      </linearGradient>
      <linearGradient id="tSkinG" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor="#7A4A2B" />
        <stop offset="100%" stopColor="#5C3620" />
      </linearGradient>
      <linearGradient id="tShirtG" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor="#F4F4F4" />
        <stop offset="100%" stopColor="#D5DBE8" />
      </linearGradient>
      <linearGradient id="tJacketG" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor="#2D6BFF" />
        <stop offset="100%" stopColor="#1947B8" />
      </linearGradient>
      <radialGradient id="tGlow" cx="50%" cy="40%" r="60%">
        <stop offset="0%" stopColor="#5B8AFF" stopOpacity=".4" />
        <stop offset="100%" stopColor="#0A1F44" stopOpacity="0" />
      </radialGradient>
    </defs>
    <rect width="400" height="500" fill="url(#tHeroBg)" />
    <circle cx="200" cy="200" r="220" fill="url(#tGlow)" />
    <g fill="#5B8AFF" opacity=".15">
      <circle cx="50" cy="60" r="2" />
      <circle cx="350" cy="80" r="2" />
      <circle cx="60" cy="420" r="2" />
      <circle cx="340" cy="450" r="2" />
      <circle cx="120" cy="40" r="1.5" />
      <circle cx="280" cy="450" r="1.5" />
    </g>
    <path
      d="M40 500 C 60 380, 130 340, 200 340 C 270 340, 340 380, 360 500 Z"
      fill="url(#tJacketG)"
    />
    <path
      d="M155 360 L200 410 L245 360 L235 500 L165 500 Z"
      fill="url(#tShirtG)"
    />
    <path d="M180 320 L220 320 L222 360 L178 360 Z" fill="url(#tSkinG)" />
    <ellipse cx="200" cy="240" rx="78" ry="92" fill="url(#tSkinG)" />
    <path
      d="M124 220 C 124 160, 160 130, 200 130 C 250 130, 280 160, 280 215
			C 280 215, 268 196, 252 196 C 236 196, 232 210, 222 200
			C 212 192, 196 198, 184 196 C 168 192, 158 200, 148 210
			C 140 218, 132 220, 124 220 Z"
      fill="#1A1410"
    />
    <ellipse cx="200" cy="260" rx="58" ry="62" fill="#6B3D24" opacity=".25" />
    <ellipse cx="178" cy="244" rx="6" ry="3.5" fill="#1A1410" />
    <ellipse cx="222" cy="244" rx="6" ry="3.5" fill="#1A1410" />
    <path
      d="M168 232 Q 178 226 188 232"
      stroke="#1A1410"
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
    />
    <path
      d="M212 232 Q 222 226 232 232"
      stroke="#1A1410"
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
    />
    <path
      d="M200 252 L195 280 Q 200 286 205 280 Z"
      fill="#5C3620"
      opacity=".5"
    />
    <path
      d="M180 296 Q 200 312 220 296"
      stroke="#3A1F12"
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
    />
    <circle cx="125" cy="252" r="3" fill="#FFD27A" />
    <path
      d="M155 360 L185 500 L165 500 L145 400 Z"
      fill="#0F2A5C"
      opacity=".7"
    />
    <path
      d="M245 360 L215 500 L235 500 L255 400 Z"
      fill="#0F2A5C"
      opacity=".7"
    />
  </svg>
);

export const DashboardIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="7" height="9" />
    <rect x="14" y="3" width="7" height="5" />
    <rect x="14" y="12" width="7" height="9" />
    <rect x="3" y="16" width="7" height="5" />
  </svg>
);

export const ArrowRight = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M5 12h14" />
    <path d="m12 5 7 7-7 7" />
  </svg>
);

export const IconSuccess = () => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);

export const FacebookIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.235 2.686.235v2.97h-1.513c-1.491 0-1.956.93-1.956 1.885v2.27h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z" />
  </svg>
);


export const TwitterIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export const InstagramIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
  </svg>
);

export const LinkedinIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

export const SendIcon = ({ onClick }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
	onClick={onClick}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.432531 0.306334C0.619116 0.14425 0.849563 0.0411162 1.09475 0.0099677C1.33993 -0.0211808 1.58884 0.0210539 1.81003 0.131334L24.31 11.3813C24.518 11.485 24.693 11.6446 24.8153 11.8422C24.9377 12.0399 25.0024 12.2677 25.0024 12.5001C25.0024 12.7325 24.9377 12.9603 24.8153 13.1579C24.693 13.3556 24.518 13.5152 24.31 13.6188L1.81003 24.8688C1.58886 24.9795 1.33983 25.0221 1.09446 24.9912C0.84909 24.9603 0.618401 24.8573 0.431585 24.6952C0.24477 24.5331 0.110225 24.3193 0.0449763 24.0808C-0.0202728 23.8422 -0.0132936 23.5897 0.0650308 23.3551L3.26753 13.7501H10.0013C10.3328 13.7501 10.6507 13.6184 10.8852 13.384C11.1196 13.1495 11.2513 12.8316 11.2513 12.5001C11.2513 12.1686 11.1196 11.8506 10.8852 11.6162C10.6507 11.3818 10.3328 11.2501 10.0013 11.2501H3.26753L0.0637806 1.64508C-0.0141402 1.4106 -0.0208174 1.15828 0.0445924 0.92C0.110002 0.681721 0.245815 0.468174 0.432531 0.306334Z"
      fill="#04097B"
    />
  </svg>
);